import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  FaTimes,
  FaBolt,
  FaHeartbeat,
  FaSolarPanel,
  FaTrashAlt,
  FaCheckCircle,
  FaArrowLeft,
  FaArrowRight,
  FaLightbulb,
  FaRecycle,
  FaCloudUploadAlt,
  FaChartBar,
  FaLeaf,
  FaSeedling,
  FaChevronRight,
  FaTint,
  FaBatteryHalf,
  FaUtensils,
  FaBan,
  FaSchool,
  FaMapMarkerAlt,
  FaUsers,
  FaCalendarAlt,
  FaRegFileAlt,
} from "react-icons/fa";
import {
  useGetBricsReportQuery,
  useSubmitBricsSaveEnergyMutation,
  useSubmitBricsHealthyLifestyleMutation,
  useSubmitPublicBricsSaveEnergyMutation,
  useSubmitPublicBricsHealthyLifestyleMutation,
} from "../../../redux/auth/authApi";
import useBackdropClose from "../useBackdropClose";
import SchoolLoginModel from "../../Authentication/SchoolLoginModel";
import axiosConn from "../../../config/axiosConn";
import StateList from "../../../helper/State_List.json";
import DistrictList from "../../../helper/District_List.json";

import bricsOfficialLogo from "../../../assets/images/brics_india_2026_logo.png";
import partnerLogosLifeIndia from "../../../assets/img/partner_logos_life_india.png";
import partnerLogosMoefccUnicef from "../../../assets/img/partner_logos_moefcc_unicef.png";
import ecoClubLogo from "../../../assets/images/Logo-2.png";
import bannerGlobeBooksImg from "../../../assets/images/Pop-up image.png";
import solarHomeImg from "../../../assets/img/Eco-Friendly Solar Home.png";
import natureMeditationImg from "../../../assets/img/Peaceful Nature Meditation.png";
import harvestBowlImg from "../../../assets/img/Fresh Harvest Bowl and Farm Fields.png";
import recyclingBinsImg from "../../../assets/img/Colorful Recycling Bins in Nature＿欧美.png";
import techRecyclingImg from "../../../assets/img/Sustainable Tech Recycling Scene.png";
import ecoLightbulbImg from "../../../assets/img/Eco Lightbulb with Lush Green Leaves.png";
import reusableBottleImg from "../../../assets/img/Reusable Bottle, Plastic-Free Living.png";

// Mission LiFE Theme Illustration Images matching Landing Page
import healthyThemeImg from "../../../assets/images/healthylife.png";
import foodThemeImg from "../../../assets/images/balanced-diet.png";
import wasteThemeImg from "../../../assets/images/reduce-waste.png";
import ewasteThemeImg from "../../../assets/images/reduce-e-waste.png";
import energyThemeImg from "../../../assets/images/save-energy.png";
import waterThemeImg from "../../../assets/images/save-water.png";
import plasticThemeImg from "../../../assets/images/single-use-plastic.png";
import { ArrowRight } from "phosphor-react";
import BricsWeekReportForm from "./BricsWeekReportForm";
import { isBricsLive } from "./bricsConfig";

import "./BricsCampaignModal.css";

const todayIST = () => new Date(Date.now() + 5.5 * 3600 * 1000).toISOString().slice(0, 10);
const defaultDateTime = () => new Date(Date.now() + 5.5 * 3600 * 1000).toISOString().slice(0, 16);

/* ── Nature & Eco Illustrations Matching Reference Redesign ─────────────── */

export const WaterRippleArt = () => (
  <svg viewBox="0 0 100 42" className="brics-ref-theme-art-svg" fill="none" preserveAspectRatio="none">
    <ellipse cx="50" cy="26" rx="36" ry="11" stroke="#93c5fd" strokeWidth="1.6" opacity="0.6" />
    <ellipse cx="50" cy="26" rx="24" ry="7.5" stroke="#60a5fa" strokeWidth="1.6" opacity="0.8" />
    <ellipse cx="50" cy="26" rx="12" ry="4" stroke="#2563eb" strokeWidth="1.6" />
    <path d="M50 11 C47 16 45 20 50 23 C55 20 53 16 50 11 Z" fill="#2563eb" />
  </svg>
);

export const WasteGrassArt = () => (
  <svg viewBox="0 0 100 42" className="brics-ref-theme-art-svg" fill="none" preserveAspectRatio="none">
    <path d="M0 42 Q50 20 100 42 Z" fill="#bbf7d0" opacity="0.55" />
    <path d="M50 36 Q43 20 36 17 Q44 24 50 36 Z" fill="#22c55e" />
    <path d="M50 36 Q57 19 64 15 Q57 24 50 36 Z" fill="#16a34a" />
  </svg>
);

export const EWasteLaptopArt = () => (
  <svg viewBox="0 0 100 42" className="brics-ref-theme-art-svg" fill="none" preserveAspectRatio="none">
    <ellipse cx="50" cy="36" rx="28" ry="4.5" fill="#facc15" opacity="0.4" />
    <path d="M28 33 L72 33 L76 37 L24 37 Z" fill="#64748b" />
    <polygon points="32,15 68,15 66,33 34,33" fill="#3b82f6" stroke="#475569" strokeWidth="1.2" />
    <polygon points="34,17 66,17 64,31 36,31" fill="#93c5fd" />
  </svg>
);

export const FoodBowlArt = () => (
  <svg viewBox="0 0 100 42" className="brics-ref-theme-art-svg" fill="none" preserveAspectRatio="none">
    <path d="M30 24 Q50 42 70 24 Z" fill="#15803d" />
    <circle cx="44" cy="22" r="6" fill="#ef4444" />
    <circle cx="56" cy="21" r="5.5" fill="#f97316" />
    <path d="M36 22 Q42 15 48 22 Z" fill="#84cc16" />
    <path d="M52 22 Q58 13 64 22 Z" fill="#22c55e" />
  </svg>
);

export const PlasticBottleArt = () => (
  <svg viewBox="0 0 100 42" className="brics-ref-theme-art-svg" fill="none" preserveAspectRatio="none">
    <g transform="translate(62, 6) rotate(15)">
      <rect x="0" y="6" width="12" height="24" rx="3.5" fill="#0284c7" />
      <rect x="2" y="2" width="8" height="5" rx="1.5" fill="#38bdf8" />
      <rect x="4" y="0" width="4" height="3" rx="1" fill="#0369a1" />
      <line x1="3" y1="12" x2="9" y2="12" stroke="#ffffff" strokeWidth="1" opacity="0.8" />
    </g>
    <path d="M46 36 Q38 27 30 29 Q38 33 46 36 Z" fill="#22c55e" />
    <path d="M46 36 Q52 27 58 31 Q52 34 46 36 Z" fill="#16a34a" />
  </svg>
);

export const GreenLeafIcon = ({ flip = false }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    style={{
      transform: flip ? "scaleX(-1) rotate(-8deg)" : "rotate(-8deg)",
      display: "inline-block",
      verticalAlign: "middle",
      margin: "0 4px",
    }}
  >
    <path
      d="M20.5 3.5C11.5 3.5 3.5 11.5 3.5 20.5C12.5 20.5 20.5 12.5 20.5 3.5Z"
      fill="#149447"
    />
    <path
      d="M3.5 20.5C9.5 14.5 15.5 8.5 20.5 3.5"
      stroke="#bbf7d0"
      strokeWidth="1.5"
      strokeLinecap="round"
      opacity="0.85"
    />
  </svg>
);

export const SproutSeedlingIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    style={{ display: "inline-block", verticalAlign: "middle", marginRight: "6px" }}
  >
    <path d="M12 21V12" stroke="#149447" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M12 12C12 7.5 7.5 6 4 6C4 10.5 7.5 12 12 12Z" fill="#149447" />
    <path d="M12 10C12 5.5 16.5 4 20 4C20 8.5 16.5 10 12 10Z" fill="#22c55e" />
  </svg>
);

export const HeaderLandscapeBg = () => (
  <div className="brics-ref-landscape-bg" aria-hidden="true">
    <svg viewBox="0 0 1000 120" preserveAspectRatio="none" className="brics-ref-landscape-svg">
      <defs>
        <linearGradient id="skyGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#e0f2fe" stopOpacity="0.8" />
          <stop offset="60%" stopColor="#f0fdf4" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="hillBack" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#bae6fd" stopOpacity="0.45" />
          <stop offset="50%" stopColor="#bbf7d0" stopOpacity="0.45" />
          <stop offset="100%" stopColor="#a7f3d0" stopOpacity="0.4" />
        </linearGradient>
        <linearGradient id="hillFront" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#86efac" stopOpacity="0.5" />
          <stop offset="50%" stopColor="#6ee7b7" stopOpacity="0.45" />
          <stop offset="100%" stopColor="#93c5fd" stopOpacity="0.4" />
        </linearGradient>
      </defs>
      <rect width="1000" height="120" fill="url(#skyGrad)" />
      <path
        d="M0 75 Q180 35 380 60 T760 45 Q880 30 1000 65 L1000 120 L0 120 Z"
        fill="url(#hillBack)"
      />
      <path
        d="M0 90 Q220 55 460 80 T820 68 Q920 60 1000 85 L1000 120 L0 120 Z"
        fill="url(#hillFront)"
      />
    </svg>
  </div>
);

export const GlobeBooksIllustration = () => (
  <div className="brics-ref-header-globe-wrap" aria-hidden="true">
    <img
      src={bannerGlobeBooksImg}
      alt="Sustainable Lifestyle Globe, Books and Windmill"
      className="brics-ref-globe-img"
    />
  </div>
);

export const SolarSchoolIllustration = () => (
  <div className="brics-ref-card-corner-art brics-ref-card-corner-art--solar-home" aria-hidden="true">
    <img
      src={solarHomeImg}
      alt="Eco-Friendly Solar Home"
      className="brics-ref-solar-home-img"
    />
  </div>
);

export const FourBinsIllustration = () => (
  <div className="brics-ref-card-corner-art brics-ref-card-corner-art--recycling-bins" aria-hidden="true">
    <img
      src={recyclingBinsImg}
      alt="Colorful Recycling Bins in Nature"
      className="brics-ref-recycling-bins-img"
    />
  </div>
);

/* ── Reference Redesign SVG Illustrations ─────────────────────────────────── */

export const HeaderEcoIllustration = () => (
  <div className="brics-ref-header-eco-graphic" aria-hidden="true">
    <svg viewBox="0 0 170 100" className="brics-ref-header-eco-svg" fill="none">
      {/* Radiant Sun in top right corner */}
      <circle cx="146" cy="20" r="10.5" fill="#facc15" />
      <g stroke="#f59e0b" strokeWidth="1.8" strokeLinecap="round" opacity="0.9">
        <line x1="146" y1="5" x2="146" y2="8" />
        <line x1="146" y1="32" x2="146" y2="35" />
        <line x1="131" y1="20" x2="134" y2="20" />
        <line x1="158" y1="20" x2="161" y2="20" />
        <line x1="135" y1="9" x2="137" y2="11" />
        <line x1="155" y1="29" x2="157" y2="31" />
        <line x1="135" y1="31" x2="137" y2="29" />
        <line x1="155" y1="11" x2="157" y2="9" />
      </g>

      {/* Wind Turbine 1 (Back left) */}
      <g stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" opacity="0.95">
        <line x1="112" y1="34" x2="114" y2="78" />
        <circle cx="112" cy="34" r="2.2" fill="#ffffff" />
        <line x1="112" y1="34" x2="112" y2="16" />
        <line x1="112" y1="34" x2="127" y2="42" />
        <line x1="112" y1="34" x2="98" y2="44" />
      </g>

      {/* Wind Turbine 2 (Back right) */}
      <g stroke="#ffffff" strokeWidth="1.6" strokeLinecap="round" opacity="0.95">
        <line x1="134" y1="44" x2="136" y2="82" />
        <circle cx="134" cy="44" r="2" fill="#ffffff" />
        <line x1="134" y1="44" x2="134" y2="28" />
        <line x1="134" y1="44" x2="147" y2="51" />
        <line x1="134" y1="44" x2="122" y2="53" />
      </g>

      {/* Earth Globe */}
      <defs>
        <clipPath id="bricsGlobeClip">
          <circle cx="78" cy="54" r="32" />
        </clipPath>
        <radialGradient id="bricsGlobeShade" cx="70%" cy="30%" r="70%">
          <stop offset="0%" stopColor="#60a5fa" />
          <stop offset="50%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#1d4ed8" />
        </radialGradient>
      </defs>

      <circle cx="78" cy="54" r="33.5" stroke="#93c5fd" strokeWidth="1.2" opacity="0.6" />
      <circle cx="78" cy="54" r="32" fill="url(#bricsGlobeShade)" />

      <g clipPath="url(#bricsGlobeClip)" fill="#22c55e">
        <path d="M68 34 Q82 30 88 40 Q94 48 85 54 Q75 58 66 52 Q62 44 68 34 Z" />
        <path d="M78 56 Q86 54 84 68 Q78 78 72 72 Q68 64 78 56 Z" fill="#16a34a" />
        <path d="M52 38 Q60 36 58 48 Q55 56 50 62 Q45 54 48 44 Z" />
        <circle cx="94" cy="62" r="3.5" />
        <circle cx="62" cy="68" r="2.5" />
        <path d="M85 32 Q96 36 94 44 Z" />
      </g>

      {/* Foreground Grass Hills */}
      <path d="M42 98 Q90 68 140 76 Q160 80 170 88 L170 100 L42 100 Z" fill="#15803d" opacity="0.9" />
      <path d="M68 100 Q110 74 150 78 Q165 80 170 85 L170 100 L68 100 Z" fill="#16a34a" opacity="0.95" />

      {/* Tilted Solar Panel */}
      <g transform="translate(100, 66)">
        <line x1="14" y1="20" x2="14" y2="28" stroke="#64748b" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="38" y1="18" x2="38" y2="28" stroke="#64748b" strokeWidth="2.5" strokeLinecap="round" />
        <polygon points="6,20 20,4 52,4 40,20" fill="#1e3a8a" stroke="#93c5fd" strokeWidth="1.6" />
        <line x1="11" y1="12" x2="46" y2="12" stroke="#93c5fd" strokeWidth="0.9" />
        <line x1="23" y1="4" x2="16" y2="20" stroke="#93c5fd" strokeWidth="0.9" />
        <line x1="33" y1="4" x2="25" y2="20" stroke="#93c5fd" strokeWidth="0.9" />
        <line x1="43" y1="4" x2="34" y2="20" stroke="#93c5fd" strokeWidth="0.9" />
      </g>

      {/* Lush Foliage along bottom right */}
      <path d="M142 96 C145 84 155 80 162 82 C160 90 152 95 142 96 Z" fill="#22c55e" />
      <path d="M150 98 C155 86 166 84 170 88 C168 96 160 98 150 98 Z" fill="#15803d" />
      <path d="M136 100 C138 90 148 88 154 92 C150 98 144 100 136 100 Z" fill="#4ade80" />
    </svg>
  </div>
);

export const BulbLeafCircleIcon = () => (
  <div className="brics-ref-badge-circle" aria-hidden="true">
    <svg viewBox="0 0 36 36" width="30" height="30" fill="none">
      <path
        d="M18 7C12.5 7 8 11.5 8 17C8 20.5 10 23.5 12 25.5C13 26.5 13.5 28 13.5 29.5H22.5C22.5 28 23 26.5 24 25.5C26 23.5 28 20.5 28 17C28 11.5 23.5 7 18 7Z"
        stroke="#14532d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="14.5" y1="29.5" x2="21.5" y2="29.5" stroke="#14532d" strokeWidth="2" strokeLinecap="round" />
      <path d="M16 32H20" stroke="#14532d" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M18 25V17C18 13.5 14.5 12.5 12.5 12.5C12.5 16 15.5 17 18 17Z"
        fill="#22c55e"
      />
      <path
        d="M18 20C18 16.5 21.5 15.5 23 15.5C23 18.5 20.5 20 18 20Z"
        fill="#15803d"
      />
    </svg>
  </div>
);

export const HeartPulseCircleIcon = ({ color = "#2563eb", className = "" }) => (
  <div className={`brics-ref-badge-circle ${className}`} aria-hidden="true">
    <svg viewBox="0 0 36 36" width="30" height="30" fill="none">
      <path
        d="M18 30C17.2 29.3 5 19.5 5 12.5C5 8.5 8.2 5.5 12.2 5.5C14.7 5.5 16.9 6.8 18 8.7C19.1 6.8 21.3 5.5 23.8 5.5C27.8 5.5 31 8.5 31 12.5C31 19.5 18.8 29.3 18 30Z"
        fill={color}
      />
      <path
        d="M7.5 14H13L15.5 9.5L18.5 19L21.5 12.5L23.5 14H28.5"
        stroke="#ffffff"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

export const LotusMeditationIllustration = () => (
  <div className="brics-ref-card-corner-art brics-ref-card-corner-art--meditation" aria-hidden="true">
    <img
      src={natureMeditationImg}
      alt="Peaceful Nature Meditation"
      className="brics-ref-meditation-img"
    />
  </div>
);

export const FoodBowlIllustration = () => (
  <svg viewBox="0 0 120 70" className="brics-ref-theme-art-svg" fill="none">
    <path d="M0 55 Q35 32 75 48 T120 40 L120 70 L0 70 Z" fill="#dcfce7" />
    <path d="M0 62 Q45 42 90 54 T120 50 L120 70 L0 70 Z" fill="#bbf7d0" />
    <circle cx="20" cy="46" r="5" fill="#16a34a" />
    <circle cx="95" cy="48" r="4" fill="#15803d" />
    <circle cx="106" cy="46" r="3.5" fill="#22c55e" />

    <path d="M35 44 C35 60 85 60 85 44 Z" fill="#15803d" />
    <ellipse cx="60" cy="44" rx="25" ry="5.5" fill="#16a34a" />

    <path d="M42 42 C38 34 46 28 50 35 C54 28 64 30 62 38" fill="#4ade80" />
    <circle cx="48" cy="40" r="7" fill="#ef4444" />
    <circle cx="46" cy="38" r="1.5" fill="#ffffff" opacity="0.6" />
    <path d="M48 33 L47 31 M48 33 L50 31" stroke="#15803d" strokeWidth="1.5" strokeLinecap="round" />

    <circle cx="68" cy="40" r="6.5" fill="#eab308" />
    <circle cx="66" cy="38" r="1.2" fill="#ffffff" opacity="0.6" />
    <circle cx="58" cy="37" r="6" fill="#f97316" />
  </svg>
);

export const ThreeDustbinsIllustration = () => (
  <svg viewBox="0 0 120 70" className="brics-ref-theme-art-svg" fill="none">
    <path d="M12 58 C8 48 16 42 22 46 C20 54 16 58 12 58 Z" fill="#22c55e" />
    <path d="M108 58 C112 48 104 42 98 46 C100 54 104 58 108 58 Z" fill="#22c55e" />

    {/* Bin 1: Green */}
    <g transform="translate(24, 22)">
      <rect x="0" y="0" width="22" height="4.5" rx="1.5" fill="#15803d" />
      <rect x="6" y="-2" width="10" height="2.5" rx="1" fill="#14532d" />
      <polygon points="2,4.5 20,4.5 18,36 4,36" fill="#22c55e" />
      <circle cx="11" cy="20" r="4.5" stroke="#ffffff" strokeWidth="1.4" strokeDasharray="5 2.5" />
    </g>

    {/* Bin 2: Blue */}
    <g transform="translate(49, 20)">
      <rect x="0" y="0" width="22" height="4.5" rx="1.5" fill="#1d4ed8" />
      <rect x="6" y="-2" width="10" height="2.5" rx="1" fill="#1e3a8a" />
      <polygon points="2,4.5 20,4.5 18,38 4,38" fill="#3b82f6" />
      <circle cx="11" cy="21" r="4.5" stroke="#ffffff" strokeWidth="1.4" strokeDasharray="5 2.5" />
    </g>

    {/* Bin 3: Yellow */}
    <g transform="translate(74, 22)">
      <rect x="0" y="0" width="22" height="4.5" rx="1.5" fill="#ca8a04" />
      <rect x="6" y="-2" width="10" height="2.5" rx="1" fill="#a16207" />
      <polygon points="2,4.5 20,4.5 18,36 4,36" fill="#eab308" />
      <circle cx="11" cy="20" r="4.5" stroke="#ffffff" strokeWidth="1.4" strokeDasharray="5 2.5" />
    </g>
  </svg>
);

export const EwasteLaptopPhoneIllustration = () => (
  <svg viewBox="0 0 120 70" className="brics-ref-theme-art-svg" fill="none">
    <path d="M16 60 C12 50 18 44 26 48 C24 56 18 60 16 60 Z" fill="#22c55e" />
    <path d="M104 60 C108 50 102 44 94 48 C96 56 102 60 104 60 Z" fill="#22c55e" />

    {/* Laptop */}
    <g transform="translate(32, 22)">
      <rect x="6" y="2" width="38" height="26" rx="2" fill="#334155" />
      <rect x="9" y="5" width="32" height="20" rx="1" fill="#60a5fa" />
      <polygon points="0,28 50,28 46,36 4,36" fill="#94a3b8" />
      <rect x="18" y="29" width="14" height="2.5" rx="0.5" fill="#cbd5e1" />
    </g>

    {/* Smartphone upright in front of laptop */}
    <g transform="translate(72, 30)">
      <rect x="0" y="0" width="16" height="28" rx="2.5" fill="#1e293b" />
      <rect x="1.5" y="2" width="13" height="22" rx="1" fill="#38bdf8" />
      <circle cx="8" cy="26" r="1" fill="#94a3b8" />
    </g>

    {/* Green Recycling Symbol above */}
    <g transform="translate(68, 6)" stroke="#22c55e" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 4 L18 4 L15 9" fill="none" />
      <path d="M22 14 L20 19 L15 17" fill="none" />
      <path d="M6 16 L4 11 L9 11" fill="none" />
      <circle cx="13" cy="12" r="7" strokeDasharray="9 5" />
    </g>
  </svg>
);

export const SaveEnergySproutBulbIllustration = () => (
  <svg viewBox="0 0 120 70" className="brics-ref-theme-art-svg" fill="none">
    <path d="M38 60 C32 54 36 46 44 50 C44 56 40 60 38 60 Z" fill="#22c55e" />
    <path d="M82 60 C88 54 84 46 76 50 C76 56 80 60 82 60 Z" fill="#22c55e" />

    <path
      d="M60 14 C48 14 42 23 42 32 C42 38 46 43 49 46 C50 47 51 49 51 51 H69 C69 49 70 47 71 46 C74 43 78 38 78 32 C78 23 72 14 60 14 Z"
      stroke="#14532d"
      strokeWidth="2"
      fill="#ffffff"
    />

    <g stroke="#94a3b8" strokeWidth="1.4" strokeLinecap="round" opacity="0.7">
      <line x1="60" y1="6" x2="60" y2="10" />
      <line x1="42" y1="12" x2="45" y2="15" />
      <line x1="78" y1="12" x2="75" y2="15" />
      <line x1="34" y1="26" x2="38" y2="27" />
      <line x1="86" y1="26" x2="82" y2="27" />
      <line x1="35" y1="40" x2="39" y2="39" />
      <line x1="85" y1="40" x2="81" y2="39" />
    </g>

    <path d="M60 48 V34" stroke="#15803d" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M60 40 C60 32 52 28 48 30 C49 37 55 40 60 40 Z" fill="#15803d" />
    <path d="M60 36 C60 28 68 25 71 27 C70 34 65 37 60 36 Z" fill="#22c55e" />

    <rect x="53" y="51" width="14" height="2.5" rx="1" fill="#64748b" />
    <rect x="54" y="54" width="12" height="2.5" rx="1" fill="#64748b" />
    <rect x="56" y="57" width="8" height="2" rx="1" fill="#475569" />
  </svg>
);

export const PlasticProhibitionIllustration = () => (
  <svg viewBox="0 0 120 70" className="brics-ref-theme-art-svg" fill="none">
    <path d="M18 60 C12 52 18 44 26 48 C24 56 20 60 18 60 Z" fill="#22c55e" />
    <path d="M102 60 C108 52 102 44 94 48 C96 56 100 60 102 60 Z" fill="#22c55e" />

    {/* Reusable Bottle */}
    <g transform="translate(36, 16)">
      <rect x="5" y="0" width="8" height="4" rx="1" fill="#0f766e" />
      <rect x="4" y="4" width="10" height="3" rx="1" fill="#14b8a6" />
      <rect x="2" y="7" width="14" height="38" rx="4" fill="#0d9488" />
      <line x1="5" y1="12" x2="5" y2="40" stroke="#5eead4" strokeWidth="1.2" opacity="0.6" strokeLinecap="round" />
    </g>

    {/* Single-Use Bag with Prohibition Sign */}
    <g transform="translate(64, 18)">
      <path
        d="M12 12 C10 6 14 2 17 2 C20 2 21 6 20 12 C24 12 28 14 28 28 C28 34 24 36 20 36 C16 36 12 36 8 36 C4 36 0 34 0 28 C0 14 4 12 8 12 C7 6 8 2 11 2 C14 2 15 6 12 12 Z"
        fill="#e2e8f0"
        stroke="#94a3b8"
        strokeWidth="1.2"
      />
      <circle cx="14" cy="22" r="14" stroke="#dc2626" strokeWidth="3" fill="none" />
      <line x1="4.5" y1="12.5" x2="23.5" y2="31.5" stroke="#dc2626" strokeWidth="3" strokeLinecap="round" />
    </g>
  </svg>
);

export const FIVE_MISSION_LIFE_THEMES = [
  {
    key: "Adopt sustainable food systems",
    line1: "Adopt Sustainable",
    line2: "Food Systems",
    colorTheme: "food",
    accentColor: "#fb923c",
    img: foodThemeImg,
    Illustration: FoodBowlIllustration,
  },
  {
    key: "Reduce Waste",
    line1: "Reduce Waste",
    line2: "",
    colorTheme: "waste",
    accentColor: "#ec4899",
    img: wasteThemeImg,
    Illustration: ThreeDustbinsIllustration,
  },
  {
    key: "Reduce E-Waste",
    line1: "Reduce E-waste",
    line2: "",
    colorTheme: "ewaste",
    accentColor: "#818cf8",
    img: ewasteThemeImg,
    Illustration: EwasteLaptopPhoneIllustration,
  },
  {
    key: "Save Energy",
    line1: "Save Energy",
    line2: "",
    colorTheme: "energy",
    accentColor: "#c084fc",
    img: energyThemeImg,
    Illustration: SaveEnergySproutBulbIllustration,
  },
  {
    key: "Say No to Single Use Plastic",
    line1: "Say No to Single Use",
    line2: "Plastic",
    colorTheme: "plastic",
    accentColor: "#eab308",
    img: plasticThemeImg,
    Illustration: PlasticProhibitionIllustration,
  },
];

export const MISSION_LIFE_THEMES = [
  { key: "Save Energy", label: "Save Energy", icon: FaBolt, themeClass: "energy" },
  { key: "Save Water", label: "Save Water", icon: FaTint, themeClass: "water", ArtComp: WaterRippleArt },
  { key: "Reduce Waste", label: "Reduce Waste", icon: FaRecycle, themeClass: "waste", ArtComp: WasteGrassArt },
  { key: "Reduce E-Waste", label: "Reduce E-Waste", icon: FaBatteryHalf, themeClass: "ewaste", ArtComp: EWasteLaptopArt },
  { key: "Adopt sustainable food systems", label: "Adopt Sustainable Food Systems", icon: FaUtensils, themeClass: "food", ArtComp: FoodBowlArt },
  { key: "Adopt Healthy Lifestyles", label: "Adopt Healthy Lifestyles", icon: FaHeartbeat, themeClass: "lifestyle" },
  { key: "Say No to Single Use Plastic", label: "Say No to Single-Use Plastic", icon: FaBan, themeClass: "plastic", ArtComp: PlasticBottleArt },
];

export const LANDING_PAGE_THEMES = [
  {
    key: "Adopt Healthy Lifestyles",
    label: "Adopt Healthy Lifestyles",
    colorClass: "",
    img: healthyThemeImg,
    imgStyle: {},
  },
  {
    key: "Adopt sustainable food systems",
    label: "Adopt Sustainable Food Systems",
    colorClass: "orange",
    img: foodThemeImg,
    imgStyle: {},
  },
  {
    key: "Reduce Waste",
    label: "Reduce Waste",
    colorClass: "orange3",
    img: wasteThemeImg,
    imgStyle: { bottom: "-12px" },
  },
  {
    key: "Reduce E-Waste",
    label: "Reduce E-waste",
    colorClass: "orange4",
    img: ewasteThemeImg,
    imgStyle: {},
  },
  {
    key: "Save Energy",
    label: "Save Energy",
    colorClass: "orange5",
    img: energyThemeImg,
    imgStyle: {},
  },
  {
    key: "Save Water",
    label: "Save Water",
    colorClass: "orange6",
    img: waterThemeImg,
    imgStyle: {},
  },
  {
    key: "Say No to Single Use Plastic",
    label: "Say No to Single Use Plastic",
    colorClass: "orange7",
    img: plasticThemeImg,
    imgStyle: {},
  },
];

export const AGE_PARTICIPATION_BRACKETS = [
  { key: "age3to8", label: "Age 3–8" },
  { key: "age8to11", label: "Age 8–11" },
  { key: "age11to14", label: "Age 11–14" },
  { key: "age14to18", label: "Age 14–18" },
  { key: "age18plus", label: "Teachers / 18+" },
];

export const MISSION_LIFE_SUB_THEMES = {
  "Save Energy": [
    "Energy saving activities like switching off tube-lights, bulbs, electronic gadgets when not in use.",
    "Knowledge building sessions on renewable sources of energy",
    "Competitions (Poster, banner, wall art etc.)",
    "Others",
  ],
  "Save Water": [
    "Tabulate water wastage in school",
    "Check for leaks in flush systems, faucets, water pipes. Report to the eco-club teacher incharge",
    "Students along with their teachers can collect water from nearby storage systems/ponds & carry out tests to check water purity",
    "Water conservation rally along with the community",
    "Awareness sessions about rainwater harvesting system & its benefits",
    "Others",
  ],
  "Say No to Single Use Plastic": [
    "Plastic audit of school campus",
    "Awareness campaigns",
    "Replace plastic water bottles with steel",
    "Others",
  ],
  "Adopt sustainable food systems": [
    "School Nutrition Garden",
    "Classroom Activities",
    "Competitions",
    "Others",
  ],
  "Reduce Waste": [
    "Cleanliness Drives",
    "Awareness on waste segregation/disposal",
    "Installation of 2-bin system in classroom",
    "Donation drives to donate old clothes, toys, furniture etc.",
    "Recycled waste art contest",
    "Interaction sessions with the rack pickers/ small junk shop dealers from the nearby locality",
    "Others",
  ],
  "Adopt Healthy Lifestyles": [
    "Plantation Drive",
    "Nature Walk",
    "Awareness session",
    "Flora QR codes",
    "Miyawaki Forest",
    "Poster Making",
    "Debate",
    "Environment Day Celebration",
    "Competitions",
    "Others",
  ],
  "Reduce E-Waste": [
    "E-waste awareness and collection drive",
    "Awareness sessions",
    "Classroom Activities",
    "Competitions",
    "Others",
  ],
};

const FOUR_BINS_DEFAULTS = [
  { key: "green", name: "Wet Waste", color: "green", label: "Green Bin" },
  { key: "blue", name: "Dry Recyclable", color: "blue", label: "Blue Bin" },
  { key: "red", name: "Hazardous / Sanitary", color: "red", label: "Red Bin" },
  { key: "black", name: "E-Waste / Other", color: "black", label: "Black Bin" },
];

/* ── Inline SVG: Green Lightbulb with Sprouting Leaves inside (Card A) ───── */
const BulbLeafIllustration = ({ size = 64 }) => (
  <svg
    className="brics-ref-bulb-svg"
    style={{ width: size, height: size }}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Radiating Yellow Glow Rays */}
    <g stroke="#facc15" strokeWidth="2.5" strokeLinecap="round" opacity="0.9">
      <line x1="40" y1="6" x2="40" y2="12" />
      <line x1="16" y1="16" x2="20" y2="20" />
      <line x1="64" y1="16" x2="60" y2="20" />
      <line x1="6" y1="40" x2="12" y2="40" />
      <line x1="74" y1="40" x2="68" y2="40" />
    </g>

    {/* Bulb Glass Body */}
    <path
      d="M40 16C27.85 16 18 25.85 18 38C18 45.5 22 51.5 26.5 56C28.5 58 30 61 30 64H50C50 61 51.5 58 53.5 56C58 51.5 62 45.5 62 38C62 25.85 52.15 16 40 16Z"
      fill="url(#bulbGrad)"
      stroke="#4ade80"
      strokeWidth="2"
    />

    {/* Highlight shine */}
    <path
      d="M24 30C26 24 32 20 38 19"
      stroke="#ffffff"
      strokeWidth="2.5"
      strokeLinecap="round"
      opacity="0.8"
    />

    {/* Two Sprouting Green Leaves inside Bulb */}
    <path d="M40 56C40 48 33 42 27 41C28 49 34 54 40 56Z" fill="#16a34a" />
    <path d="M40 56C40 46 48 40 54 39C53 48 47 54 40 56Z" fill="#22c55e" />
    <path d="M40 56V44" stroke="#15803d" strokeWidth="2" strokeLinecap="round" />

    {/* Screw Base */}
    <rect x="31" y="64" width="18" height="3" rx="1.5" fill="#15803d" />
    <rect x="33" y="68" width="14" height="3" rx="1.5" fill="#15803d" />
    <rect x="35" y="72" width="10" height="2.5" rx="1" fill="#0f5132" />

    <defs>
      <radialGradient id="bulbGrad" cx="40" cy="36" r="24" gradientUnits="userSpaceOnUse">
        <stop stopColor="#fef08a" />
        <stop offset="0.45" stopColor="#bbf7d0" />
        <stop offset="1" stopColor="#86efac" />
      </radialGradient>
    </defs>
  </svg>
);

/* ── Inline SVG: Vibrant Blue Heart with White Pulse Line (Card B) ───────── */
const HeartPulseIllustration = ({ size = 64 }) => (
  <svg
    className="brics-ref-heart-svg"
    style={{ width: size, height: size }}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Blue Heart Shape */}
    <path
      d="M40 70C38 68 12 50 12 30C12 20 20 12 30 12C36 12 40 16 40 16C40 16 44 12 50 12C60 12 68 20 68 30C68 50 42 68 40 70Z"
      fill="url(#heartGrad)"
      filter="drop-shadow(0 4px 10px rgba(37, 99, 235, 0.35))"
    />

    {/* Top Lobe Gloss Reflection */}
    <path
      d="M20 25C22 19 28 16 32 16"
      stroke="#ffffff"
      strokeWidth="2.5"
      strokeLinecap="round"
      opacity="0.5"
    />

    {/* White ECG Heartbeat Pulse Line */}
    <path
      d="M16 38H28L32 30L38 46L44 26L48 42L52 38H64"
      stroke="#ffffff"
      strokeWidth="3.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <defs>
      <linearGradient id="heartGrad" x1="12" y1="12" x2="68" y2="70" gradientUnits="userSpaceOnUse">
        <stop stopColor="#3b82f6" />
        <stop offset="0.5" stopColor="#2563eb" />
        <stop offset="1" stopColor="#1d4ed8" />
      </linearGradient>
    </defs>
  </svg>
);

export default function BricsCampaignModal({
  isOpen,
  initialView = "announcement",
  onClose,
  onCompleted,
  schoolData = null,
  udiseId = "",
  publicReport = null,
}) {
  const authUser = useSelector((state) => state?.auth?.user) || {};
  const effectiveUdise = udiseId || schoolData?.udise_id || schoolData?.udise || authUser?.udise_id || "";
  const effectiveSchoolName = schoolData?.school_name || authUser?.school_name || "";
  const effectiveState = schoolData?.state || authUser?.state || "";
  const effectiveDistrict = schoolData?.district || authUser?.district || "";
  const effectiveBlock = schoolData?.block || authUser?.block || "";
  const user = {
    ...authUser,
    udise_id: effectiveUdise,
    school_name: effectiveSchoolName,
    state: effectiveState,
    district: effectiveDistrict,
    block: effectiveBlock,
  };
  const isSchool = authUser?.role === 2 || Boolean(effectiveUdise);
  // A public visitor also has an effectiveUdise (they typed one and we looked it
  // up), so isSchool is NOT enough to call the login-only routes — doing that is
  // what produced "Please login to access this resource" on the public page.
  const isAuthedSchool = Boolean(authUser?.udise_id);
  const dispatch = useDispatch();

  const [existingEvents, setExistingEvents] = useState([]);
  const [selectedExistingEventId, setSelectedExistingEventId] = useState("");

  // RTK Query for BRICS report data
  const { data: authedBrics, refetch } = useGetBricsReportQuery(undefined, {
    skip: !isOpen || !isAuthedSchool,
  });
  // Logged in → the authed query; public → whatever the UDISE lookup returned,
  // so a public visitor still sees and can edit what that school already sent.
  const bricsData = isAuthedSchool ? authedBrics : publicReport;
  const refetchIfAuthed = () => { if (isAuthedSchool) refetch(); };
  const [submitSaveEnergy, { isLoading: isSubmittingEnergy }] = useSubmitBricsSaveEnergyMutation();
  const [submitPublicSaveEnergy, { isLoading: isSubmittingPublicEnergy }] = useSubmitPublicBricsSaveEnergyMutation();
  const [submitHealthyLifestyle, { isLoading: isSubmittingLifestyle }] = useSubmitBricsHealthyLifestyleMutation();
  const [submitPublicHealthyLifestyle, { isLoading: isSubmittingPublicLifestyle }] = useSubmitPublicBricsHealthyLifestyleMutation();

  // Active view: 'announcement' | 'save_energy' | 'adopt_lifestyle' | 'success'
  const [activeView, setActiveView] = useState(initialView || "announcement");
  const [successType, setSuccessType] = useState("");

  useEffect(() => {
    if (isOpen) {
      if (initialView && ["save_energy", "adopt_lifestyle"].includes(initialView)) {
        setActiveView(initialView);
      } else {
        setActiveView("announcement");
      }
    }
  }, [isOpen, initialView]);

  // Form State: Save Energy
  const [energyForm, setEnergyForm] = useState({
    sub_theme: "",
    electricityBillReduction: "",
    reductionPct: 15,
    reductionAmount: "",
    reductionUnit: "%",
    solarPanelInstalled: "no",
    solarUnitsGenerated: "",
    energyAuditDone: "yes",
    oneHourSwitchOffObserved: "yes",
    studentsInvolved: "",
    age3to8: "",
    age8to11: "",
    age11to14: "",
    age14to18: "",
    age18plus: "",
    activityDate: todayIST(),
    photos: [],
    remarks: "",
  });

  // Form State: Adopt Healthy Lifestyle
  const [lifestyleForm, setLifestyleForm] = useState({
    sub_theme: "",
    fourBinSystemInstalled: "no", // Metric: Four-bin system installed – Yes/No
    wasteSegregatedAtSource: "yes",
    fourBinsCategories: [
      "Biodegradable / Wet Waste (Green)",
      "Dry Recyclable Waste (Blue)",
      "E-Waste (Red/Black)",
      "Hazardous / Sanitary Waste (Yellow)",
    ],
    binsCount: "1",
    number_of_trees_Planted: "",
    number_of_trees_Planted_Miyawaki: "",
    visits_organised: "",
    number_of_trees_labelled_qr: "",
    studentsSensitised: "",
    age3to8: "",
    age8to11: "",
    age11to14: "",
    age14to18: "",
    age18plus: "",
    activityDate: todayIST(),
    photos: [],
    remarks: "",
  });

  // Pre-fill from fetched report, existingEvents, or localStorage
  useEffect(() => {
    const saved = bricsData?.report;
    // No localStorage prefill: the saved report comes from the server
    // (bricsData for a logged-in school, the UDISE lookup for a public one).
    const localSaved = {};

    const matchedEnergyEv = existingEvents.find(
      (ev) =>
        ev.theme_name === "Save Energy" ||
        ev.theme_name?.toLowerCase() === "save energy"
    );

    if (saved?.saveEnergy || localSaved?.saveEnergy || matchedEnergyEv) {
      const e = {
        ...(saved?.saveEnergy || {}),
        ...(localSaved?.saveEnergy || {}),
      };
      const evMatrix = matchedEnergyEv?.matrix || {};
      const evSubTheme =
        matchedEnergyEv?.sub_themes &&
        (Array.isArray(matchedEnergyEv.sub_themes)
          ? matchedEnergyEv.sub_themes[0]
          : matchedEnergyEv.sub_themes);
      const evPhotos = Array.isArray(matchedEnergyEv?.photos)
        ? matchedEnergyEv.photos
        : [];

      setEnergyForm((prev) => ({
        ...prev,
        sub_theme:
          e.sub_theme ||
          (Array.isArray(e.subThemes) && e.subThemes[0]) ||
          "",
        electricityBillReduction:
          e.electricityBillReduction ||
          evMatrix.electricityBillReduction ||
          prev.electricityBillReduction,
        reductionPct:
          e.reductionPct != null
            ? e.reductionPct
            : evMatrix.reductionPct != null
            ? evMatrix.reductionPct
            : prev.reductionPct,
        reductionAmount:
          e.reductionAmount != null
            ? e.reductionAmount
            : evMatrix.reductionAmount != null
            ? evMatrix.reductionAmount
            : prev.reductionAmount,
        reductionUnit:
          e.reductionUnit || evMatrix.reductionUnit || prev.reductionUnit,
        solarPanelInstalled:
          e.solarPanelInstalled ||
          evMatrix.solarPanelInstalled ||
          prev.solarPanelInstalled,
        solarUnitsGenerated:
          e.solarUnitsGenerated != null
            ? e.solarUnitsGenerated
            : evMatrix.solarUnitsGenerated != null
            ? evMatrix.solarUnitsGenerated
            : prev.solarUnitsGenerated,
        energyAuditDone:
          e.energyAuditDone || evMatrix.energyAuditDone || prev.energyAuditDone,
        oneHourSwitchOffObserved:
          e.oneHourSwitchOffObserved ||
          evMatrix.oneHourSwitchOffObserved ||
          prev.oneHourSwitchOffObserved,
        studentsInvolved:
          e.studentsInvolved ||
          matchedEnergyEv?.number_participant_age8to11 ||
          prev.studentsInvolved,
        age3to8:
          e.age3to8 ??
          e.ageWiseParticipation?.age3to8 ??
          matchedEnergyEv?.number_participant_age3to8 ??
          prev.age3to8,
        age8to11:
          e.age8to11 ??
          e.ageWiseParticipation?.age8to11 ??
          matchedEnergyEv?.number_participant_age8to11 ??
          prev.age8to11,
        age11to14:
          e.age11to14 ??
          e.ageWiseParticipation?.age11to14 ??
          matchedEnergyEv?.number_participant_age11to14 ??
          prev.age11to14,
        age14to18:
          e.age14to18 ??
          e.ageWiseParticipation?.age14to18 ??
          matchedEnergyEv?.number_participant_age14to18 ??
          prev.age14to18,
        age18plus:
          e.age18plus ??
          e.ageWiseParticipation?.age18plus ??
          matchedEnergyEv?.number_participant_age18plus ??
          prev.age18plus,
        activityDate: e.activityDate
          ? String(e.activityDate).slice(0, 10)
          : matchedEnergyEv?.event_date
          ? String(matchedEnergyEv.event_date).slice(0, 10)
          : prev.activityDate,
        photos:
          Array.isArray(e.photos) && e.photos.length > 0
            ? e.photos
            : evPhotos.length > 0
            ? evPhotos
            : prev.photos,
        remarks: e.remarks || matchedEnergyEv?.desc || prev.remarks,
      }));
    }

    const matchedLifestyleEv = existingEvents.find(
      (ev) =>
        ev.theme_name === "Adopt Healthy Lifestyles" ||
        ev.theme_name?.toLowerCase() === "adopt healthy lifestyles"
    );

    if (saved?.adoptHealthyLifestyle || localSaved?.adoptHealthyLifestyle || matchedLifestyleEv) {
      const l = {
        ...(saved?.adoptHealthyLifestyle || {}),
        ...(localSaved?.adoptHealthyLifestyle || {}),
      };
      const evMatrix = matchedLifestyleEv?.matrix || {};
      const evSubTheme =
        matchedLifestyleEv?.sub_themes &&
        (Array.isArray(matchedLifestyleEv.sub_themes)
          ? matchedLifestyleEv.sub_themes[0]
          : matchedLifestyleEv.sub_themes);
      const evPhotos = Array.isArray(matchedLifestyleEv?.photos)
        ? matchedLifestyleEv.photos
        : [];

      setLifestyleForm((prev) => ({
        ...prev,
        sub_theme:
          l.sub_theme ||
          (Array.isArray(l.subThemes) && l.subThemes[0]) ||
          "",
        fourBinSystemInstalled:
          l.fourBinSystemInstalled ||
          evMatrix.fourBinSystemInstalled ||
          prev.fourBinSystemInstalled,
        wasteSegregatedAtSource:
          l.wasteSegregatedAtSource ||
          evMatrix.wasteSegregatedAtSource ||
          prev.wasteSegregatedAtSource,
        fourBinsCategories:
          Array.isArray(l.fourBinsCategories) && l.fourBinsCategories.length > 0
            ? l.fourBinsCategories
            : Array.isArray(evMatrix.fourBinsCategories) && evMatrix.fourBinsCategories.length > 0
            ? evMatrix.fourBinsCategories
            : prev.fourBinsCategories,
        binsCount:
          l.binsCount != null
            ? l.binsCount
            : evMatrix.binsCount != null
            ? evMatrix.binsCount
            : prev.binsCount,
        number_of_trees_Planted:
          l.number_of_trees_Planted ??
          evMatrix.number_of_trees_Planted ??
          matchedLifestyleEv?.number_of_trees_Planted ??
          prev.number_of_trees_Planted,
        number_of_trees_Planted_Miyawaki:
          l.number_of_trees_Planted_Miyawaki ??
          evMatrix.number_of_trees_Planted_Miyawaki ??
          matchedLifestyleEv?.number_of_trees_Planted_Miyawaki ??
          prev.number_of_trees_Planted_Miyawaki,
        visits_organised:
          l.visits_organised ??
          evMatrix.visits_organised ??
          matchedLifestyleEv?.visits_organised ??
          prev.visits_organised,
        number_of_trees_labelled_qr:
          l.number_of_trees_labelled_qr ??
          evMatrix.number_of_trees_labelled_qr ??
          matchedLifestyleEv?.number_of_trees_labelled_qr ??
          prev.number_of_trees_labelled_qr,
        studentsSensitised:
          l.studentsSensitised != null
            ? l.studentsSensitised
            : prev.studentsSensitised,
        age3to8:
          l.age3to8 ??
          l.ageWiseParticipation?.age3to8 ??
          matchedLifestyleEv?.number_participant_age3to8 ??
          prev.age3to8,
        age8to11:
          l.age8to11 ??
          l.ageWiseParticipation?.age8to11 ??
          matchedLifestyleEv?.number_participant_age8to11 ??
          prev.age8to11,
        age11to14:
          l.age11to14 ??
          l.ageWiseParticipation?.age11to14 ??
          matchedLifestyleEv?.number_participant_age11to14 ??
          prev.age11to14,
        age14to18:
          l.age14to18 ??
          l.ageWiseParticipation?.age14to18 ??
          matchedLifestyleEv?.number_participant_age14to18 ??
          prev.age14to18,
        age18plus:
          l.age18plus ??
          l.ageWiseParticipation?.age18plus ??
          matchedLifestyleEv?.number_participant_age18plus ??
          prev.age18plus,
        activityDate: l.activityDate
          ? String(l.activityDate).slice(0, 10)
          : matchedLifestyleEv?.event_date
          ? String(matchedLifestyleEv.event_date).slice(0, 10)
          : prev.activityDate,
        photos:
          Array.isArray(l.photos) && l.photos.length > 0
            ? l.photos
            : evPhotos.length > 0
            ? evPhotos
            : prev.photos,
        remarks: l.remarks || matchedLifestyleEv?.desc || prev.remarks,
      }));
    }
  }, [bricsData, user?.udise_id, existingEvents, activeView]);

  // ONLY brics_campaign_reports decides whether an initiative is done.
  //
  // This used to also trust localStorage and the school's themeregistrations
  // events, and both lied: the local key falls back to "brics_report_school"
  // when the UDISE is missing (so it leaks between schools), and matching on
  // theme_name marked BRICS as filled for any school that had run an
  // "Adopt Healthy Lifestyles" or "Save Energy" event before — Ek Ped Maa Ke
  // Naam 3.0 writes exactly those theme names, so schools were locked out of a
  // form they had never opened.
  const isEnergyDone =
    Boolean(bricsData?.status?.saveEnergySubmitted) ||
    bricsData?.report?.saveEnergy?.status === "submitted";

  const isLifestyleDone =
    Boolean(bricsData?.status?.adoptHealthyLifestyleSubmitted) ||
    bricsData?.report?.adoptHealthyLifestyle?.status === "submitted";

  const backdropHandlers = useBackdropClose(onClose);

  // File upload handler
  const handlePhotoUpload = async (e, formType) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    for (const file of files) {
      if (file.size > 5 * 1024 * 1024) {
        toast.error(`File "${file.name}" exceeds 5MB size limit.`);
        return;
      }
    }

    try {
      let lat = 0;
      let lng = 0;
      if (typeof navigator !== "undefined" && navigator.geolocation) {
        try {
          const pos = await new Promise((res, rej) => {
            navigator.geolocation.getCurrentPosition(res, rej, {
              enableHighAccuracy: true,
              timeout: 10000,
              maximumAge: 30000,
            });
          });
          lat = pos.coords.latitude;
          lng = pos.coords.longitude;
        } catch (geoErr) {
          console.warn("Could not retrieve device geolocation:", geoErr);
        }
      }

      const formData = new FormData();
      files.forEach((f) => formData.append("files", f));
      formData.append("latitude", String(lat));
      formData.append("longitude", String(lng));

      try {
        const res = await axiosConn("post", "upload-collaboration-file", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        const urls = res?.data?.status === "success" ? res.data.data || [] : [];
        if (urls.length) {
          const newPhotos = urls.map((u) => ({ url: u, latitude: lat, longitude: lng }));
          if (formType === "energy") {
            setEnergyForm((prev) => ({ ...prev, photos: [...prev.photos, ...newPhotos].slice(0, 5) }));
          } else {
            setLifestyleForm((prev) => ({ ...prev, photos: [...prev.photos, ...newPhotos].slice(0, 5) }));
          }
          toast.success("Photos uploaded successfully!");
          return;
        }
      } catch (uploadErr) {
        console.warn("Backend upload failed, using local preview data:", uploadErr);
      }

      files.forEach((f) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const previewObj = { url: event.target.result };
          if (formType === "energy") {
            setEnergyForm((prev) => ({ ...prev, photos: [...prev.photos, previewObj].slice(0, 5) }));
          } else {
            setLifestyleForm((prev) => ({ ...prev, photos: [...prev.photos, previewObj].slice(0, 5) }));
          }
        };
        reader.readAsDataURL(f);
      });
      toast.info("Photos added to report!");
    } catch (err) {
      toast.error("Failed to process photo upload.");
    }
  };

  const removePhoto = (index, formType) => {
    if (formType === "energy") {
      setEnergyForm((prev) => ({
        ...prev,
        photos: prev.photos.filter((_, i) => i !== index),
      }));
    } else {
      setLifestyleForm((prev) => ({
        ...prev,
        photos: prev.photos.filter((_, i) => i !== index),
      }));
    }
  };

  // Live totals for age-wise participants
  const energyAgeTotal =
    (Number(energyForm.age3to8) || 0) +
    (Number(energyForm.age8to11) || 0) +
    (Number(energyForm.age11to14) || 0) +
    (Number(energyForm.age14to18) || 0) +
    (Number(energyForm.age18plus) || 0);

  const lifestyleAgeTotal =
    (Number(lifestyleForm.age3to8) || 0) +
    (Number(lifestyleForm.age8to11) || 0) +
    (Number(lifestyleForm.age11to14) || 0) +
    (Number(lifestyleForm.age14to18) || 0) +
    (Number(lifestyleForm.age18plus) || 0);

  // A public visitor may fill a school's form once. After that the report can
  // only be changed from the school login, so the fields are locked and the
  // submit disabled rather than letting them type into a form the server will
  // refuse (BRICS_LOGIN_TO_EDIT).
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const energyLocked = isEnergyDone && !isAuthedSchool;
  const lifestyleLocked = isLifestyleDone && !isAuthedSchool;

  // Nothing filled in = nothing to report. Without this an empty form saved a
  // blank row, which then blocked the school from reporting properly.
  const anyValue = (...vals) => vals.some((v) => Number(v) > 0);

  // A failed submit must never be reported as saved: the school would walk away
  // believing it reported when nothing reached the server. Surface what the
  // server said — BRICS_LOGIN_TO_EDIT and BRICS_CLOSED carry real instructions.
  const reportSubmitFailure = (err, label) => {
    const d = err?.data || err?.error?.data || {};
    if (d.code === "BRICS_LOGIN_TO_EDIT") {
      toast.error(d.message || "To edit these details, please login to the school dashboard.");
    } else if (d.code === "BRICS_CLOSED") {
      toast.error(d.message || "BRICS Sustainable Lifestyle Week is closed.");
    } else if (d.message) {
      toast.error(d.message);
    } else {
      toast.error(`${label} could not be submitted. Please check your connection and try again.`);
    }
  };

  // Submit Save Energy Form
  const handleSubmitEnergy = async (e) => {
    e?.preventDefault();

    if (energyLocked) {
      setShowLoginPrompt(true);
      return;
    }
    if (energyForm.solarPanelInstalled === "yes" && (!energyForm.solarUnitsGenerated || Number(energyForm.solarUnitsGenerated) < 0)) {
      toast.warning("Please enter the Units of solar power generated.");
      return;
    }
    if (
      !anyValue(
        energyForm.reductionPct, energyForm.reductionAmount, energyForm.solarUnitsGenerated,
        energyForm.studentsInvolved, energyAgeTotal
      ) && !(energyForm.photos || []).length && !String(energyForm.electricityBillReduction || "").trim()
    ) {
      toast.warning("Please fill in at least one detail before submitting the Save Energy report.");
      return;
    }

    try {
      const studentsTotal = energyAgeTotal > 0 ? energyAgeTotal : Number(energyForm.studentsInvolved) || 0;
      const payload = {
        sub_theme: energyForm.sub_theme || (MISSION_LIFE_SUB_THEMES["Save Energy"] || [])[0] || "",
        electricityBillReduction: energyForm.electricityBillReduction || `${energyForm.reductionPct}% reduction in electricity bills`,
        reductionPct: Number(energyForm.reductionPct) || 0,
        reductionAmount: Number(energyForm.reductionAmount) || 0,
        reductionUnit: energyForm.reductionUnit,
        solarPanelInstalled: energyForm.solarPanelInstalled,
        solarUnitsGenerated: Number(energyForm.solarUnitsGenerated) || 0,
        energyAuditDone: energyForm.energyAuditDone,
        oneHourSwitchOffObserved: energyForm.oneHourSwitchOffObserved,
        studentsInvolved: studentsTotal,
        age3to8: Number(energyForm.age3to8) || 0,
        age8to11: Number(energyForm.age8to11) || 0,
        age11to14: Number(energyForm.age11to14) || 0,
        age14to18: Number(energyForm.age14to18) || 0,
        age18plus: Number(energyForm.age18plus) || 0,
        ageWiseParticipation: {
          age3to8: Number(energyForm.age3to8) || 0,
          age8to11: Number(energyForm.age8to11) || 0,
          age11to14: Number(energyForm.age11to14) || 0,
          age14to18: Number(energyForm.age14to18) || 0,
          age18plus: Number(energyForm.age18plus) || 0,
          total: studentsTotal,
        },
        activityDate: energyForm.activityDate,
        photos: energyForm.photos,
        remarks: energyForm.remarks,
      };

      if (!authUser?.udise_id && effectiveUdise) {
        await submitPublicSaveEnergy({ ...payload, udise_id: effectiveUdise, school: user }).unwrap();
      } else {
        await submitSaveEnergy(payload).unwrap();
      }


      toast.success("Save Energy report submitted successfully!");
      setSuccessType("energy");
      setActiveView("success");
      if (typeof onCompleted === "function") onCompleted();
      refetchIfAuthed();
      window.dispatchEvent(new Event('themeUpdated'));
      window.dispatchEvent(new Event('eWasteUpdated'));
      if (isAuthedSchool) {
        axiosConn("post", "get-themes", { udise_id: user.udise_id }, {}, dispatch)
          .then((res) => {
            if (res?.data?.status === "success" && Array.isArray(res.data.data)) {
              setExistingEvents(res.data.data.filter((ev) => ev.status === 1 || ev.status === 2));
            }
          })
          .catch(() => {});
      }
    } catch (err) {
      console.error("Save energy submit error:", err);
      reportSubmitFailure(err, "Save Energy report");
    }
  };

  // Submit Adopt Healthy Lifestyle Form
  const handleSubmitLifestyle = async (e) => {
    e?.preventDefault();

    if (lifestyleLocked) {
      setShowLoginPrompt(true);
      return;
    }
    if (lifestyleForm.fourBinSystemInstalled === "yes" && (!lifestyleForm.binsCount || Number(lifestyleForm.binsCount) <= 0)) {
      toast.warning("Please enter number of 4-bin sets installed.");
      return;
    }
    if (
      !anyValue(
        lifestyleForm.binsCount, lifestyleForm.studentsSensitised, lifestyleAgeTotal,
        lifestyleForm.number_of_trees_Planted, lifestyleForm.number_of_trees_Planted_Miyawaki,
        lifestyleForm.visits_organised, lifestyleForm.number_of_trees_labelled_qr
      ) && !(lifestyleForm.photos || []).length && lifestyleForm.fourBinSystemInstalled !== "yes"
    ) {
      toast.warning("Please fill in at least one detail before submitting the Healthy Lifestyle report.");
      return;
    }

    try {
      const studentsTotal = lifestyleAgeTotal > 0 ? lifestyleAgeTotal : Number(lifestyleForm.studentsSensitised) || 0;
      const payload = {
        sub_theme: lifestyleForm.sub_theme || (MISSION_LIFE_SUB_THEMES["Adopt Healthy Lifestyles"] || [])[0] || "",
        fourBinSystemInstalled: lifestyleForm.fourBinSystemInstalled, // Metric: Four-bin system installed – Yes/No
        wasteSegregatedAtSource: lifestyleForm.wasteSegregatedAtSource,
        fourBinsCategories: lifestyleForm.fourBinsCategories,
        binsCount: Number(lifestyleForm.binsCount) || 0,
        number_of_trees_Planted: Number(lifestyleForm.number_of_trees_Planted) || 0,
        number_of_trees_Planted_Miyawaki: Number(lifestyleForm.number_of_trees_Planted_Miyawaki) || 0,
        visits_organised: Number(lifestyleForm.visits_organised) || 0,
        number_of_trees_labelled_qr: Number(lifestyleForm.number_of_trees_labelled_qr) || 0,
        studentsSensitised: studentsTotal,
        age3to8: Number(lifestyleForm.age3to8) || 0,
        age8to11: Number(lifestyleForm.age8to11) || 0,
        age11to14: Number(lifestyleForm.age11to14) || 0,
        age14to18: Number(lifestyleForm.age14to18) || 0,
        age18plus: Number(lifestyleForm.age18plus) || 0,
        ageWiseParticipation: {
          age3to8: Number(lifestyleForm.age3to8) || 0,
          age8to11: Number(lifestyleForm.age8to11) || 0,
          age11to14: Number(lifestyleForm.age11to14) || 0,
          age14to18: Number(lifestyleForm.age14to18) || 0,
          age18plus: Number(lifestyleForm.age18plus) || 0,
          total: studentsTotal,
        },
        activityDate: lifestyleForm.activityDate,
        photos: lifestyleForm.photos,
        remarks: lifestyleForm.remarks,
      };

      if (!authUser?.udise_id && effectiveUdise) {
        await submitPublicHealthyLifestyle({ ...payload, udise_id: effectiveUdise, school: user }).unwrap();
      } else {
        await submitHealthyLifestyle(payload).unwrap();
      }


      setLifestyleForm((prev) => ({
        ...prev,
        ...payload,
      }));

      toast.success("Adopt Healthy Lifestyle report submitted successfully!");
      setSuccessType("lifestyle");
      setActiveView("success");
      if (typeof onCompleted === "function") onCompleted();
      refetchIfAuthed();
      if (typeof window !== "undefined") {
        window.dispatchEvent(new Event('themeUpdated'));
        window.dispatchEvent(new Event('eWasteUpdated'));
      }
      if (isAuthedSchool) {
        axiosConn("post", "get-themes", { udise_id: user.udise_id }, {}, dispatch)
          .then((res) => {
            if (res?.data?.status === "success" && Array.isArray(res.data.data)) {
              setExistingEvents(res.data.data.filter((ev) => ev.status === 1 || ev.status === 2));
            }
          })
          .catch(() => {});
      }
    } catch (err) {
      console.error("Healthy lifestyle submit error:", err);
      reportSubmitFailure(err, "Adopt Healthy Lifestyle report");
    }
  };

  // ── Create Event Form State (Matching "Create Event" page) ───────────────
  const [filterDistrict, setFilterDistrict] = useState([]);
  const [isSubmittingEvent, setIsSubmittingEvent] = useState(false);

  const [eventForm, setEventForm] = useState({
    _id: "",
    event_name: "",
    desc: "",
    theme_name: "Save Water",
    sub_theme: "",
    implemnt_mode: "Physical",
    event_type: "Action & Awareness both",
    number_events: 1,
    event_date: defaultDateTime(),
    state: "",
    district: "",
    city: "",
    isEventTechIntervention: "Yes",
    haveParticipantPledge: "Yes",
    number_participant_age3to8: "",
    number_participant_age8to11: "",
    number_participant_age11to14: "",
    number_participant_age14to18: "",
    number_participant_age18plus: "",
    photos: [],
    photo_caption: "",
    videos: "",
    video_caption: "",
    // Theme impact metrics:
    leaks_detected: "",
    Reduction_in_water: "",
    compost_pits_constructed: "Yes",
    organic_waste_generated: "",
    Amount_of_ewaste_collected: "",
    kitchen_gardens_created: "Yes",
    Amount_of_organic_produce: "",
    Single_Use_Plastic_Free: "Yes",
    single_use_plastic_collected: "",
    number_of_trees_Planted: "",
    number_of_trees_Planted_Miyawaki: "",
    visits_organised: "",
    number_of_trees_labelled_qr: "",
    fourBinSystemInstalled: "yes",
    solarPanelInstalled: "yes",
    solarUnitsGenerated: "",
    reductionPct: "15",
  });

  useEffect(() => {
    if (user) {
      const uState = user?.state || "";
      const uDistrict = user?.district || "";
      const stateObj = StateList.find(
        (s) => s.state_name?.toLowerCase() === uState.toLowerCase()
      );
      if (stateObj) {
        const matching = DistrictList.filter((d) => d.state_id === stateObj.state_id);
        setFilterDistrict(matching);
      }
      setEventForm((prev) => ({
        ...prev,
        state: uState,
        district: uDistrict,
        city: user?.city || "",
      }));
    }
  }, [user]);

  // Fetch school's registered events and refetch report when modal is open or view changes
  useEffect(() => {
    // get-themes is login-only too — a public visitor must never reach it.
    if (isAuthedSchool && isOpen) {
      refetchIfAuthed();
      axiosConn("post", "get-themes", { udise_id: user.udise_id }, {}, dispatch)
        .then((res) => {
          if (res?.data?.status === "success" && Array.isArray(res.data.data)) {
            setExistingEvents(res.data.data.filter((ev) => ev.status === 1 || ev.status === 2));
          }
        })
        .catch((err) => {
          console.log("Could not load existing events:", err);
        });
    }
  }, [isAuthedSchool, user?.udise_id, isOpen, activeView, refetch, dispatch]);

  const handleStateSelect = (stateName) => {
    const stateObj = StateList.find((s) => s.state_name === stateName);
    const matching = stateObj ? DistrictList.filter((d) => d.state_id === stateObj.state_id) : [];
    setFilterDistrict(matching);
    setEventForm((prev) => ({
      ...prev,
      state: stateName,
      district: matching[0]?.district_name || "",
    }));
  };

  const [selectedTheme, setSelectedTheme] = useState(null);

  const handleOpenCreateEvent = (themeKey) => {
    const subList = MISSION_LIFE_SUB_THEMES[themeKey] || [];
    setSelectedTheme(themeKey);

    const existing = existingEvents.find(
      (ev) =>
        ev.theme_name === themeKey ||
        ev.theme_name?.toLowerCase() === themeKey?.toLowerCase()
    );
    if (existing) {
      setSelectedExistingEventId(existing._id);
      const matrix = existing.matrix || {};
      const subThemes = Array.isArray(existing.sub_themes)
        ? existing.sub_themes[0]
        : (existing.sub_themes || "");
      setEventForm({
        _id: existing._id,
        event_name: existing.event_name || `${themeKey} Initiative`,
        desc: existing.desc || `${themeKey} activity conducted by school eco-club.`,
        theme_name: existing.theme_name || themeKey,
        sub_theme: subThemes || "",
        implemnt_mode: existing.implemnt_mode || "Physical",
        event_type: existing.event_type || "Action & Awareness both",
        number_events: existing.number_events || 1,
        event_date: existing.event_date ? new Date(existing.event_date).toISOString().slice(0, 16) : defaultDateTime(),
        state: existing.state || user?.state || "",
        district: existing.district || user?.district || "",
        city: existing.city || user?.city || "",
        isEventTechIntervention: existing.isEventTechIntervention || "Yes",
        haveParticipantPledge: existing.haveParticipantPledge || "Yes",
        number_participant_age3to8: existing.number_participant_age3to8 || "",
        number_participant_age8to11: existing.number_participant_age8to11 || "",
        number_participant_age11to14: existing.number_participant_age11to14 || "",
        number_participant_age14to18: existing.number_participant_age14to18 || "",
        number_participant_age18plus: existing.number_participant_age18plus || "",
        photos: Array.isArray(existing.photos) ? existing.photos : [],
        photo_caption: existing.photo_caption || "",
        videos: existing.videos || "",
        video_caption: existing.video_caption || "",
        leaks_detected: matrix.leaks_detected || "",
        Reduction_in_water: matrix.Reduction_in_water || "",
        compost_pits_constructed: matrix.compost_pits_constructed || "Yes",
        organic_waste_generated: matrix.organic_waste_generated || "",
        Amount_of_ewaste_collected: matrix.Amount_of_ewaste_collected || "",
        kitchen_gardens_created: matrix.kitchen_gardens_created || "Yes",
        Amount_of_organic_produce: matrix.Amount_of_organic_produce || "",
        Single_Use_Plastic_Free: matrix.Single_Use_Plastic_Free || "Yes",
        single_use_plastic_collected: matrix.single_use_plastic_collected || "",
        number_of_trees_Planted: matrix.number_of_trees_Planted || "",
        number_of_trees_Planted_Miyawaki: matrix.number_of_trees_Planted_Miyawaki || "",
        visits_organised: matrix.visits_organised || "",
        number_of_trees_labelled_qr: matrix.number_of_trees_labelled_qr || "",
        fourBinSystemInstalled: matrix.fourBinSystemInstalled || "yes",
        solarPanelInstalled: matrix.solarPanelInstalled || "yes",
        solarUnitsGenerated: matrix.solarUnitsGenerated || "",
        reductionPct: matrix.reductionPct || "15",
      });
    } else {
      setSelectedExistingEventId("");
      setEventForm((prev) => ({
        ...prev,
        _id: "",
        event_name: `${themeKey} Initiative`,
        desc: `${themeKey} activity conducted by school eco-club.`,
        theme_name: themeKey,
        sub_theme: "",
        event_type: "Action & Awareness both",
        number_events: 1,
        event_date: defaultDateTime(),
        isEventTechIntervention: "Yes",
        haveParticipantPledge: "Yes",
        number_participant_age3to8: "",
        number_participant_age8to11: "",
        number_participant_age11to14: "",
        number_participant_age14to18: "",
        number_participant_age18plus: "",
        photos: [],
        photo_caption: "",
        videos: "",
        video_caption: "",
        leaks_detected: "",
        Reduction_in_water: "",
        compost_pits_constructed: "Yes",
        organic_waste_generated: "",
        Amount_of_ewaste_collected: "",
        kitchen_gardens_created: "Yes",
        Amount_of_organic_produce: "",
        Single_Use_Plastic_Free: "Yes",
        single_use_plastic_collected: "",
        number_of_trees_Planted: "",
        number_of_trees_Planted_Miyawaki: "",
        visits_organised: "",
        number_of_trees_labelled_qr: "",
        fourBinSystemInstalled: "yes",
        solarPanelInstalled: "yes",
        solarUnitsGenerated: "",
        reductionPct: "15",
      }));
    }
    setActiveView("create_event");
  };

  const handleThemeDropdownChange = (newTheme) => {
    setSelectedTheme(newTheme);
    setEventForm((prev) => ({
      ...prev,
      theme_name: newTheme,
      sub_theme: "",
    }));
  };

  const handleSelectExistingEvent = (eventId) => {
    setSelectedExistingEventId(eventId);
    if (!eventId) {
      setEventForm((prev) => ({
        ...prev,
        _id: "",
        event_name: "",
        desc: "",
        theme_name: selectedTheme || prev.theme_name,
        sub_theme: (MISSION_LIFE_SUB_THEMES[selectedTheme || prev.theme_name] || [])[0] || "",
        event_type: "Action & Awareness both",
        number_events: 1,
        event_date: defaultDateTime(),
        isEventTechIntervention: "Yes",
        haveParticipantPledge: "Yes",
        number_participant_age3to8: "",
        number_participant_age8to11: "",
        number_participant_age11to14: "",
        number_participant_age14to18: "",
        number_participant_age18plus: "",
        photos: [],
        photo_caption: "",
        videos: "",
        video_caption: "",
        leaks_detected: "",
        Reduction_in_water: "",
        compost_pits_constructed: "Yes",
        organic_waste_generated: "",
        Amount_of_ewaste_collected: "",
        kitchen_gardens_created: "Yes",
        Amount_of_organic_produce: "",
        Single_Use_Plastic_Free: "Yes",
        single_use_plastic_collected: "",
        number_of_trees_Planted: "",
        fourBinSystemInstalled: "yes",
        solarPanelInstalled: "yes",
        solarUnitsGenerated: "",
      }));
      return;
    }

    const item = existingEvents.find((e) => e._id === eventId);
    if (item) {
      const matrix = item.matrix || {};
      const subThemes = Array.isArray(item.sub_themes)
        ? item.sub_themes[0]
        : (item.sub_themes || "");
      setSelectedTheme(item.theme_name);
      setEventForm({
        _id: item._id,
        event_name: item.event_name || "",
        desc: item.desc || "",
        theme_name: item.theme_name || selectedTheme,
        sub_theme: subThemes || (MISSION_LIFE_SUB_THEMES[item.theme_name] || [])[0] || "",
        implemnt_mode: item.implemnt_mode || "Physical",
        event_type: "Action & Awareness both",
        number_events: item.number_events || 1,
        event_date: item.event_date ? new Date(item.event_date).toISOString().slice(0, 16) : defaultDateTime(),
        state: item.state || user?.state || "",
        district: item.district || user?.district || "",
        city: item.city || user?.city || "",
        isEventTechIntervention: item.isEventTechIntervention || "Yes",
        haveParticipantPledge: item.haveParticipantPledge || "Yes",
        number_participant_age3to8: item.number_participant_age3to8 || "",
        number_participant_age8to11: item.number_participant_age8to11 || "",
        number_participant_age11to14: item.number_participant_age11to14 || "",
        number_participant_age14to18: item.number_participant_age14to18 || "",
        number_participant_age18plus: item.number_participant_age18plus || "",
        photos: Array.isArray(item.photos) ? item.photos : [],
        photo_caption: item.photo_caption || "",
        videos: typeof item.videos === "string" ? item.videos : "",
        video_caption: item.video_caption || "",
        leaks_detected: matrix.leaks_detected ?? item.leaks_detected ?? "",
        Reduction_in_water: matrix.Reduction_in_water ?? item.Reduction_in_water ?? "",
        compost_pits_constructed: matrix.compost_pits_constructed ?? item.compost_pits_constructed ?? "Yes",
        organic_waste_generated: matrix.organic_waste_generated ?? item.organic_waste_generated ?? "",
        Amount_of_ewaste_collected: matrix.Amount_of_ewaste_collected ?? item.Amount_of_ewaste_collected ?? "",
        kitchen_gardens_created: matrix.kitchen_gardens_created ?? item.kitchen_gardens_created ?? "Yes",
        Amount_of_organic_produce: matrix.Amount_of_organic_produce ?? item.Amount_of_organic_produce ?? "",
        Single_Use_Plastic_Free: matrix.Single_Use_Plastic_Free ?? item.Single_Use_Plastic_Free ?? "Yes",
        single_use_plastic_collected: matrix.single_use_plastic_collected ?? item.single_use_plastic_collected ?? "",
        number_of_trees_Planted: matrix.number_of_trees_Planted ?? item.number_of_trees_Planted ?? "",
        fourBinSystemInstalled: matrix.fourBinSystemInstalled ?? item.fourBinSystemInstalled ?? "yes",
        solarPanelInstalled: matrix.solarPanelInstalled ?? item.solarPanelInstalled ?? "yes",
        solarUnitsGenerated: matrix.solarUnitsGenerated ?? item.solarUnitsGenerated ?? "",
      });
    }
  };

  const handleEventPhotoUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const currentCount = eventForm.photos?.length || 0;
    const remainingSlots = 5 - currentCount;
    if (remainingSlots <= 0) {
      toast.warning("Maximum 5 photos allowed");
      return;
    }
    const filesToUpload = files.slice(0, remainingSlots);

    for (const file of filesToUpload) {
      if (file.size > 5 * 1024 * 1024) {
        toast.error(`File "${file.name}" exceeds 5MB size limit.`);
        return;
      }
    }

    try {
      let lat = 0;
      let lng = 0;
      if (typeof navigator !== "undefined" && navigator.geolocation) {
        try {
          const pos = await new Promise((res, rej) => {
            navigator.geolocation.getCurrentPosition(res, rej, {
              enableHighAccuracy: true,
              timeout: 10000,
              maximumAge: 30000,
            });
          });
          lat = pos.coords.latitude;
          lng = pos.coords.longitude;
        } catch (geoErr) {
          console.warn("Could not retrieve device geolocation:", geoErr);
        }
      }

      const formData = new FormData();
      filesToUpload.forEach((f) => formData.append("files", f));
      formData.append("latitude", String(lat));
      formData.append("longitude", String(lng));

      try {
        const res = await axiosConn("post", "upload-image-file", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        const urls = res?.data?.status === "success" ? res.data.data || [] : [];
        if (urls.length) {
          const newPhotos = urls.map((u, i) => ({
            photo_url: u,
            url: u,
            name: filesToUpload[i]?.name || `photo_${i}`,
            latitude: lat,
            longitude: lng,
          }));
          setEventForm((prev) => ({
            ...prev,
            photos: [...(prev.photos || []), ...newPhotos].slice(0, 5),
          }));
          toast.success("Photos uploaded successfully!");
          return;
        }
      } catch (uploadErr) {
        console.warn("Upload to server failed, using local preview data:", uploadErr);
      }

      filesToUpload.forEach((f) => {
        const reader = new FileReader();
        reader.onload = (ev) => {
          const item = {
            photo_url: ev.target.result,
            url: ev.target.result,
            name: f.name,
            latitude: 0,
            longitude: 0,
          };
          setEventForm((prev) => ({
            ...prev,
            photos: [...(prev.photos || []), item].slice(0, 5),
          }));
        };
        reader.readAsDataURL(f);
      });
      toast.info("Photos added to report!");
    } catch (err) {
      toast.error("Failed to process photo upload.");
    }
  };

  const removeEventPhoto = (idx) => {
    setEventForm((prev) => ({
      ...prev,
      photos: (prev.photos || []).filter((_, i) => i !== idx),
    }));
  };

  const eventParticipantsTotal = [
    eventForm.number_participant_age3to8,
    eventForm.number_participant_age8to11,
    eventForm.number_participant_age11to14,
    eventForm.number_participant_age14to18,
    eventForm.number_participant_age18plus,
  ].reduce((acc, v) => acc + (Number(v) || 0), 0);


  const getThemeMeta = (themeKey) => {
    return MISSION_LIFE_THEMES.find((t) => t.key === themeKey) || MISSION_LIFE_THEMES[0];
  };

  const activeSelectedTheme =
    activeView === "save_energy"
      ? "Save Energy"
      : activeView === "adopt_lifestyle"
      ? "Adopt Healthy Lifestyles"
      : activeView === "create_event"
      ? eventForm.theme_name
      : selectedTheme;

  const selectedThemeMeta = activeSelectedTheme ? getThemeMeta(activeSelectedTheme) : null;


  const handleSubmitCreateEvent = async (e) => {
    e.preventDefault();
    if (isSubmittingEvent) return;

    const resolvedSubTheme =
      eventForm.sub_theme ||
      (MISSION_LIFE_SUB_THEMES[eventForm.theme_name] || [])[0] ||
      "";
    if (!eventForm.number_events || !/^\d{1,3}$/.test(String(eventForm.number_events))) {
      toast.warning("Enter a valid number of events (1 - 999)");
      return;
    }
    if (!eventForm.event_date) {
      toast.warning("Please Enter The Date and Time");
      return;
    }

    if (eventForm.theme_name === "Adopt Healthy Lifestyles") {
      if (eventForm.sub_theme === "Miyawaki Forest") {
        if (!eventForm.number_of_trees_Planted_Miyawaki) {
          toast.warning("Please enter number of trees planted.");
          return;
        }
        if (Number(eventForm.number_of_trees_Planted_Miyawaki) > 20000) {
          toast.warning("Maximum allowed trees is 20000.");
          return;
        }
      } else if (eventForm.sub_theme === "Flora QR codes") {
        if (!eventForm.number_of_trees_labelled_qr) {
          toast.warning("Please enter number of trees labelled with QR code.");
          return;
        }
        if (Number(eventForm.number_of_trees_labelled_qr) > 5000) {
          toast.warning("Maximum allowed trees labelled is 5000.");
          return;
        }
      } else if (eventForm.sub_theme === "Nature Walk") {
        if (!eventForm.visits_organised) {
          toast.warning("Please enter number of nature walks conducted.");
          return;
        }
        if (Number(eventForm.visits_organised) > 500) {
          toast.warning("Maximum allowed nature walks is 500.");
          return;
        }
      } else if (eventForm.sub_theme) {
        if (!eventForm.number_of_trees_Planted) {
          toast.warning("Please enter number of trees planted.");
          return;
        }
        if (Number(eventForm.number_of_trees_Planted) > 100) {
          toast.warning("Maximum allowed trees is 100.");
          return;
        }
      }
    }

    setIsSubmittingEvent(true);
    try {
      const matrix = {
        leaks_detected: eventForm.leaks_detected,
        Reduction_in_water: eventForm.Reduction_in_water,
        compost_pits_constructed: eventForm.compost_pits_constructed,
        organic_waste_generated: eventForm.organic_waste_generated,
        Amount_of_ewaste_collected: eventForm.Amount_of_ewaste_collected,
        kitchen_gardens_created: eventForm.kitchen_gardens_created,
        Amount_of_organic_produce: eventForm.Amount_of_organic_produce,
        Single_Use_Plastic_Free: eventForm.Single_Use_Plastic_Free,
        single_use_plastic_collected: eventForm.single_use_plastic_collected,
        number_of_trees_Planted: eventForm.number_of_trees_Planted,
        number_of_trees_Planted_Miyawaki: eventForm.number_of_trees_Planted_Miyawaki,
        visits_organised: eventForm.visits_organised,
        number_of_trees_labelled_qr: eventForm.number_of_trees_labelled_qr,
        fourBinSystemInstalled: eventForm.fourBinSystemInstalled,
        solarPanelInstalled: eventForm.solarPanelInstalled,
        solarUnitsGenerated: eventForm.solarUnitsGenerated,
        reductionPct: eventForm.reductionPct,
        electricity_units_consumed: eventForm.solarPanelInstalled,
        Units_of_renewable_power_generated: eventForm.solarUnitsGenerated,
      };

      const effectiveEventName =
        (eventForm.event_name && eventForm.event_name.trim()) ||
        `${eventForm.theme_name || "Mission LiFE"} Initiative`;

      const effectiveDesc =
        (eventForm.desc && eventForm.desc.trim()) ||
        `${eventForm.theme_name || "Mission LiFE"} activity conducted by school eco-club.`;

      const effectiveState = eventForm.state || user?.state || "State";
      const effectiveDistrict = eventForm.district || user?.district || "District";
      const effectiveCity = eventForm.city || user?.city || "School Campus";

      const postData = {
        udise_id: user?.udise_id,
        school_name: user?.school_name,
        event_name: effectiveEventName,
        desc: effectiveDesc,
        theme_name: eventForm.theme_name,
        sub_themes: [resolvedSubTheme || "General"],
        implemnt_mode: eventForm.implemnt_mode || "Physical",
        event_type: "Action & Awareness both",
        number_events: String(eventForm.number_events || 1),
        event_date: eventForm.event_date || defaultDateTime(),
        state: effectiveState,
        district: effectiveDistrict,
        city: effectiveCity,
        isEventTechIntervention: eventForm.isEventTechIntervention || "Yes",
        haveParticipantPledge: eventForm.haveParticipantPledge || "Yes",
        number_participant_age3to8: String(eventForm.number_participant_age3to8 || 0),
        number_participant_age8to11: String(eventForm.number_participant_age8to11 || 0),
        number_participant_age11to14: String(eventForm.number_participant_age11to14 || 0),
        number_participant_age14to18: String(eventForm.number_participant_age14to18 || 0),
        number_participant_age18plus: String(eventForm.number_participant_age18plus || 0),
        photos: (eventForm.photos || [])
          .map((p) => {
            if (!p) return null;
            const photoUrl = typeof p === "string" ? p : (p.photo_url || p.url || "");
            if (!photoUrl) return null;
            const lat = Number(p.latitude);
            const lng = Number(p.longitude);
            return {
              photo_url: photoUrl,
              latitude: Number.isFinite(lat) ? lat : 0,
              longitude: Number.isFinite(lng) ? lng : 0,
            };
          })
          .filter(Boolean),
        photo_caption: eventForm.photo_caption || "",
        videos: eventForm.videos || "",
        video_caption: eventForm.video_caption || "",
        matrix,
        lang: user?.lang || "en-IN",
        assigned_teacher: [user?.email],
        auther: user?.email,
      };

      let res;
      if (eventForm._id) {
        postData._id = eventForm._id;
        res = await axiosConn(
          "post",
          "update-theme",
          postData,
          { "Content-Type": "application/json" },
          dispatch
        );
      } else {
        res = await axiosConn(
          "post",
          "save-theme",
          postData,
          { "Content-Type": "application/json" },
          dispatch
        );
      }

      if (res?.data?.status === "success" || res?.status === 200) {
        toast.success(
          eventForm._id
            ? "Event Management Report Updated Successfully!"
            : "Event Management Report Submitted Successfully!"
        );
        if (typeof window !== "undefined") {
          window.dispatchEvent(new Event("themeUpdated"));
          window.dispatchEvent(new Event("eWasteUpdated"));
        }
        if (isAuthedSchool) {
          axiosConn("post", "get-themes", { udise_id: user.udise_id }, {}, dispatch)
            .then((themeRes) => {
              if (themeRes?.data?.status === "success" && Array.isArray(themeRes.data.data)) {
                setExistingEvents(themeRes.data.data.filter((ev) => ev.status === 1 || ev.status === 2));
              }
            })
            .catch(() => {});
        }
        setActiveView("announcement");
        if (typeof onCompleted === "function") onCompleted();
      } else {
        toast.error(res?.data?.message || "Failed to submit event report");
      }
    } catch (err) {
      console.error("Event Management submit error:", err);
      const msg = err?.response?.data?.message || err?.message || "An error occurred during submission. Please try again.";
      toast.error(msg);
    } finally {
      setIsSubmittingEvent(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="brics-ref-overlay" {...backdropHandlers}>
      <div
        className={`brics-ref-card ${
          activeView === "announcement"
            ? "brics-ref-card--overview"
            : activeView === "create_event"
            ? "brics-ref-card--event"
            : "brics-ref-card--form"
        }`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="brics-campaign-heading"
      >
        {/* Top Subtle Sky/Green Glow */}
        <div className="brics-ref-top-glow" />

        {/* Header Row: Campaign Blue with Serif Heading, Partner & Campaign Logos, Globe & Close */}
        <div className="brics-ref-header">
          {/* Left: BRICS INDIA 2026 Official Logo + LiFE & Government of India */}
          <div className="brics-ref-header-left">
            <div className="brics-ref-logo-badge" title="BRICS INDIA 2026">
              <img
                src={bricsOfficialLogo}
                alt="BRICS INDIA 2026"
                className="brics-ref-brics-logo"
              />
            </div>
            <div
              className="brics-ref-partners-badge"
              title="LiFE (Lifestyle for Environment) • Government of India"
            >
              <img
                src={partnerLogosLifeIndia}
                alt="LiFE, Government of India"
                className="brics-ref-partners-logo brics-ref-partners-logo--left"
              />
            </div>
          </div>

          {/* Center: Serif Heading & Subtitle */}
          <div className="brics-ref-heading-wrap brics-ref-heading-wrap--header">
            <h3 id="brics-campaign-heading" className="brics-ref-heading">
              BRICS Sustainable Lifestyle Week 2026
            </h3>
            <div className="brics-ref-subtitle">
              <span className="brics-ref-header-dash" />
              <span className="brics-ref-subtitle-text">ONE WEEK, SEVEN ACTIONS, ONE PLANET
              </span>
              <span className="brics-ref-header-dash" />
            </div>
          </div>

          {/* Right Section: MoEF&CC, UNICEF & Globe */}
          <div className="brics-ref-header-right">
            <div
              className="brics-ref-partners-badge"
              title="Ministry of Environment, Forest and Climate Change • UNICEF"
            >
              <img
                src={partnerLogosMoefccUnicef}
                alt="Ministry of Environment Forest and Climate Change, UNICEF"
                className="brics-ref-partners-logo brics-ref-partners-logo--right"
              />
            </div>
            <GlobeBooksIllustration />
          </div>

          {/* Circular Close Button at Top-Right Corner */}
          <button
            type="button"
            className="brics-ref-close-btn"
            onClick={onClose}
            title="Close"
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </div>

        {effectiveSchoolName && (
          <div className="brics-modal-school-strip">
            <FaSchool style={{ color: "#0284c7" }} />
            <span style={{ color: "#0f172a", fontWeight: "700" }}>{effectiveSchoolName}</span>
            <span style={{ opacity: 0.5 }}>•</span>
            <span style={{ background: "#0284c7", color: "#fff", padding: "2px 8px", borderRadius: "10px", fontSize: "11px", letterSpacing: "0.5px" }}>UDISE: {effectiveUdise}</span>
            {effectiveDistrict && (
              <span style={{ color: "#475569", fontWeight: "500" }}>
                ({[effectiveDistrict, effectiveState].filter(Boolean).join(", ")})
              </span>
            )}
          </div>
        )}

        {/* ══════════════════════════════════════════════════════════════════════
            VIEW 1: REFERENCE DESIGN OVERVIEW (Matching Reference Image Exactly)
            ══════════════════════════════════════════════════════════════════════ */}
        {activeView === "announcement" && (
          <div className="brics-ref-overview-body">
            {/* ── School Reporting: the 8 questions the campaign is measured on ──
                This replaced the Mission LiFE theme tiles. The tiles only led
                to the generic event form; what the campaign actually collects
                is the seven answers below, so they are asked here directly. */}
            <div className="brics-ref-life-container">
              {effectiveUdise ? (
                <BricsWeekReportForm
                  report={bricsData?.report}
                  prefill={bricsData?.prefill}
                  canSubmit={isBricsLive()}
                  closedMessage="BRICS Sustainable Lifestyle Week runs from 1 to 7 November 2026."
                  isPublic={!isAuthedSchool}
                  udiseId={effectiveUdise}
                  onRequireLogin={() => setShowLoginPrompt(true)}
                  onSubmitted={refetchIfAuthed}
                />
              ) : (
                <div className="brics-ref-signin">
                  <SproutSeedlingIcon />
                  <h4>School Reporting</h4>
                  <p>
                    Eight questions on what your school did during the week. Enter your UDISE code
                    on this page, or sign in to the school dashboard, to fill the form.
                  </p>
                  <button type="button" className="brics-ref-signin__btn" onClick={() => setShowLoginPrompt(true)}>
                    Sign in to report
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* ══════════════════════════════════════════════════════════════════════
            VIEW: EVENT MANAGEMENT FORM FOR MISSION LIFE THEMES
            ══════════════════════════════════════════════════════════════════════ */}
        {activeView === "create_event" && (
          <>
            {/* Top Sub-Nav with Back */}
            <div className="brics-ref-form-nav">
              <button
                type="button"
                className="brics-ref-back-btn"
                onClick={() => setActiveView("announcement")}
              >
                <FaArrowLeft /> Back to Overview
              </button>
              {selectedThemeMeta && (
                <div className="brics-ref-form-nav-theme-badge">
                  <span>Theme:</span> <strong>{selectedThemeMeta.label}</strong>
                </div>
              )}
            </div>

            {/* Scrollable Event Management Form Body */}
            <form className="brics-ref-form-body" onSubmit={handleSubmitCreateEvent}>
              <div className="brics-form-two-column-grid">
                {/* ── Left Column: Event Schedule & Theme Impact ── */}
                <div className="brics-form-column">
                  {/* Card 1: Event Schedule & Sub-Theme */}
                  <div className="brics-ref-section-card">
                    <div className="brics-ref-metric-title">
                      <FaLeaf style={{ color: "#16a34a" }} /> Event Schedule & Sub-Theme
                    </div>

                    <div className="brics-ref-input-grid">
                      <div className="brics-ref-field">
                        <label className="brics-ref-label">
                          Date and Time: <span className="req">*</span>
                        </label>
                        <input
                          type="datetime-local"
                          className="brics-ref-input"
                          value={eventForm.event_date}
                          onChange={(e) => setEventForm({ ...eventForm, event_date: e.target.value })}
                          required
                        />
                      </div>

                      <div className="brics-ref-field">
                        <label className="brics-ref-label">
                          Number of Events: <span className="req">*</span>
                        </label>
                        <input
                          type="number"
                          className="brics-ref-input"
                          min="1"
                          max="999"
                          value={eventForm.number_events}
                          onChange={(e) => setEventForm({ ...eventForm, number_events: e.target.value })}
                          required
                        />
                      </div>
                    </div>

                    <div className="brics-ref-field" style={{ marginTop: "4px" }}>
                      <label className="brics-ref-label">
                        Mission LiFE Sub-Theme: <span className="req">*</span>
                      </label>
                      <select
                        className="brics-ref-select"
                        value={eventForm.sub_theme}
                        onChange={(e) => setEventForm({ ...eventForm, sub_theme: e.target.value })}
                      >
                        <option value="">-- Select Sub-Theme (Default Theme Metrics) --</option>
                        {(MISSION_LIFE_SUB_THEMES[eventForm.theme_name] || []).map((st, i) => (
                          <option key={i} value={st}>
                            {st}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Card 2: Sub-Theme Specific Impact Metric Question */}
                  <div className="brics-ref-section-card">
                    <div className="brics-ref-metric-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
                      <span>
                        <FaChartBar style={{ color: "#16a34a" }} /> Impact Metric Question
                      </span>
                      {eventForm.sub_theme ? (
                        <span
                          className="brics-ref-tag-pill"
                          style={{
                            fontSize: "11px",
                            fontWeight: "600",
                            background: "#f0fdf4",
                            color: "#15803d",
                            border: "1px solid #bbf7d0",
                            padding: "2px 8px",
                            borderRadius: "12px",
                            maxWidth: "260px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={eventForm.sub_theme}
                        >
                          {eventForm.sub_theme}
                        </span>
                      ) : (
                        <span
                          className="brics-ref-tag-pill"
                          style={{
                            fontSize: "11px",
                            fontWeight: "600",
                            background: "#eff6ff",
                            color: "#1d4ed8",
                            border: "1px solid #bfdbfe",
                            padding: "2px 8px",
                            borderRadius: "12px",
                          }}
                        >
                          Default Theme Metrics
                        </span>
                      )}
                    </div>

                    {/* ── Save Water Metrics ── */}
                    {eventForm.theme_name === "Save Water" && (
                      <>
                        {eventForm.sub_theme === "Check for leaks in flush systems, faucets, water pipes. Report to the eco-club teacher incharge" ? (
                          <div className="brics-ref-field">
                            <label className="brics-ref-label">Number of Leaks Detected & Fixed: <span className="req">*</span></label>
                            <input
                              type="number"
                              min="0"
                              className="brics-ref-input"
                              placeholder="e.g. 12 leaks fixed"
                              value={eventForm.leaks_detected}
                              onChange={(e) => setEventForm({ ...eventForm, leaks_detected: e.target.value })}
                            />
                          </div>
                        ) : eventForm.sub_theme && eventForm.sub_theme !== "Others" ? (
                          <div className="brics-ref-field">
                            <label className="brics-ref-label">Water Saved (Liters or %): <span className="req">*</span></label>
                            <input
                              type="number"
                              min="0"
                              className="brics-ref-input"
                              placeholder="e.g. 500 Liters"
                              value={eventForm.Reduction_in_water}
                              onChange={(e) => setEventForm({ ...eventForm, Reduction_in_water: e.target.value })}
                            />
                          </div>
                        ) : (
                          /* By default or "Others" */
                          <div className="brics-ref-input-grid">
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">Number of Leaks Detected & Fixed:</label>
                              <input
                                type="number"
                                min="0"
                                className="brics-ref-input"
                                placeholder="e.g. 12 leaks"
                                value={eventForm.leaks_detected}
                                onChange={(e) => setEventForm({ ...eventForm, leaks_detected: e.target.value })}
                              />
                            </div>
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">Water Saved (Liters or %):</label>
                              <input
                                type="number"
                                min="0"
                                className="brics-ref-input"
                                placeholder="e.g. 500 Liters"
                                value={eventForm.Reduction_in_water}
                                onChange={(e) => setEventForm({ ...eventForm, Reduction_in_water: e.target.value })}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {/* ── Reduce Waste Metrics ── */}
                    {eventForm.theme_name === "Reduce Waste" && (
                      <>
                        {eventForm.sub_theme && eventForm.sub_theme !== "Installation of 2-bin system in classroom" && eventForm.sub_theme !== "Others" ? (
                          <div className="brics-ref-field">
                            <label className="brics-ref-label">Amount of Waste Collected / Diverted (Kg): <span className="req">*</span></label>
                            <input
                              type="number"
                              min="0"
                              className="brics-ref-input"
                              placeholder="e.g. 45 Kg"
                              value={eventForm.organic_waste_generated}
                              onChange={(e) => setEventForm({ ...eventForm, organic_waste_generated: e.target.value })}
                            />
                          </div>
                        ) : (
                          /* By default or "Installation of 2-bin system in classroom" or "Others" */
                          <div className="brics-ref-input-grid">
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">2-Bin System / Compost Pit Constructed?</label>
                              <select
                                className="brics-ref-select"
                                value={eventForm.compost_pits_constructed}
                                onChange={(e) => setEventForm({ ...eventForm, compost_pits_constructed: e.target.value })}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </div>
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">Waste Collected / Segregated (Kg):</label>
                              <input
                                type="number"
                                min="0"
                                className="brics-ref-input"
                                placeholder="e.g. 45 Kg"
                                value={eventForm.organic_waste_generated}
                                onChange={(e) => setEventForm({ ...eventForm, organic_waste_generated: e.target.value })}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {/* ── Reduce E-Waste Metrics ── */}
                    {eventForm.theme_name === "Reduce E-Waste" && (
                      <div className="brics-ref-field">
                        <label className="brics-ref-label">Amount of E-Waste Collected (Kg, Max 100): <span className="req">*</span></label>
                        <input
                          type="number"
                          min="0"
                          max="100"
                          className="brics-ref-input"
                          placeholder="e.g. 25 Kg"
                          value={eventForm.Amount_of_ewaste_collected}
                          onChange={(e) => setEventForm({ ...eventForm, Amount_of_ewaste_collected: e.target.value })}
                        />
                      </div>
                    )}

                    {/* ── Adopt Sustainable Food Systems Metrics ── */}
                    {eventForm.theme_name === "Adopt sustainable food systems" && (
                      <>
                        {eventForm.sub_theme && eventForm.sub_theme !== "School Nutrition Garden" && eventForm.sub_theme !== "Others" ? (
                          <div className="brics-ref-field">
                            <label className="brics-ref-label">Harvest Produced / Food Waste Diverted (Kg):</label>
                            <input
                              type="number"
                              min="0"
                              className="brics-ref-input"
                              placeholder="e.g. 30 Kg"
                              value={eventForm.Amount_of_organic_produce}
                              onChange={(e) => setEventForm({ ...eventForm, Amount_of_organic_produce: e.target.value })}
                            />
                          </div>
                        ) : (
                          /* By default or "School Nutrition Garden" or "Others" */
                          <div className="brics-ref-input-grid">
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">Nutrition Garden / Kitchen Garden Established?</label>
                              <select
                                className="brics-ref-select"
                                value={eventForm.kitchen_gardens_created}
                                onChange={(e) => setEventForm({ ...eventForm, kitchen_gardens_created: e.target.value })}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </div>
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">Harvest Produced (Kg):</label>
                              <input
                                type="number"
                                min="0"
                                className="brics-ref-input"
                                placeholder="e.g. 30 Kg"
                                value={eventForm.Amount_of_organic_produce}
                                onChange={(e) => setEventForm({ ...eventForm, Amount_of_organic_produce: e.target.value })}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {/* ── Say No to Single Use Plastic Metrics ── */}
                    {eventForm.theme_name === "Say No to Single Use Plastic" && (
                      <>
                        {eventForm.sub_theme === "Replace plastic water bottles with steel" ? (
                          <div className="brics-ref-field">
                            <label className="brics-ref-label">Plastic Bottles Replaced / Plastic Diverted (Kg): <span className="req">*</span></label>
                            <input
                              type="number"
                              min="0"
                              className="brics-ref-input"
                              placeholder="e.g. 35 Kg"
                              value={eventForm.single_use_plastic_collected}
                              onChange={(e) => setEventForm({ ...eventForm, single_use_plastic_collected: e.target.value })}
                            />
                          </div>
                        ) : (
                          /* By default or "Plastic audit" or "Awareness campaigns" or "Others" */
                          <div className="brics-ref-input-grid">
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">Single Use Plastic Free School?</label>
                              <select
                                className="brics-ref-select"
                                value={eventForm.Single_Use_Plastic_Free}
                                onChange={(e) => setEventForm({ ...eventForm, Single_Use_Plastic_Free: e.target.value })}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </div>
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">Plastic Collected (Kg):</label>
                              <input
                                type="number"
                                min="0"
                                className="brics-ref-input"
                                placeholder="e.g. 15 Kg"
                                value={eventForm.single_use_plastic_collected}
                                onChange={(e) => setEventForm({ ...eventForm, single_use_plastic_collected: e.target.value })}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {/* ── Adopt Healthy Lifestyles Metrics ── */}
                    {eventForm.theme_name === "Adopt Healthy Lifestyles" && (
                      <>
                        {eventForm.sub_theme === "Miyawaki Forest" ? (
                          <div className="brics-ref-field">
                            <label className="brics-ref-label">Number of Trees Planted in Miyawaki Forest: <span className="req">*</span></label>
                            <input
                              type="number"
                              min="0"
                              max="20000"
                              className="brics-ref-input"
                              placeholder="e.g. 100 trees (Max 20,000)"
                              value={eventForm.number_of_trees_Planted_Miyawaki}
                              onChange={(e) => setEventForm({ ...eventForm, number_of_trees_Planted_Miyawaki: e.target.value })}
                            />
                          </div>
                        ) : eventForm.sub_theme === "Flora QR codes" ? (
                          <div className="brics-ref-field">
                            <label className="brics-ref-label">Number of trees labelled with QR code: <span className="req">*</span></label>
                            <input
                              type="number"
                              min="0"
                              max="5000"
                              className="brics-ref-input"
                              placeholder="e.g. 50 trees labelled"
                              value={eventForm.number_of_trees_labelled_qr}
                              onChange={(e) => setEventForm({ ...eventForm, number_of_trees_labelled_qr: e.target.value })}
                            />
                          </div>
                        ) : eventForm.sub_theme === "Nature Walk" ? (
                          <div className="brics-ref-field">
                            <label className="brics-ref-label">Number of Nature walks conducted: <span className="req">*</span></label>
                            <input
                              type="number"
                              min="0"
                              max="500"
                              className="brics-ref-input"
                              placeholder="e.g. 5 nature walks"
                              value={eventForm.visits_organised}
                              onChange={(e) => setEventForm({ ...eventForm, visits_organised: e.target.value })}
                            />
                          </div>
                        ) : eventForm.sub_theme ? (
                          /* Plantation Drive & Any other selected sub-theme */
                          <div className="brics-ref-field">
                            <label className="brics-ref-label">No. of Trees Planted: <span className="req">*</span></label>
                            <input
                              type="number"
                              min="0"
                              max="100"
                              className="brics-ref-input"
                              placeholder="e.g. 50 saplings (Max 100)"
                              value={eventForm.number_of_trees_Planted}
                              onChange={(e) => setEventForm({ ...eventForm, number_of_trees_Planted: e.target.value })}
                            />
                          </div>
                        ) : (
                          /* By Default (no sub-theme selected): display default theme metric questions */
                          <div className="brics-ref-input-grid">
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">Four-Bin System Installed in School?</label>
                              <select
                                className="brics-ref-select"
                                value={eventForm.fourBinSystemInstalled}
                                onChange={(e) => setEventForm({ ...eventForm, fourBinSystemInstalled: e.target.value })}
                              >
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                              </select>
                            </div>
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">Trees / Saplings Planted (Optional):</label>
                              <input
                                type="number"
                                min="0"
                                className="brics-ref-input"
                                placeholder="e.g. 20 saplings"
                                value={eventForm.number_of_trees_Planted}
                                onChange={(e) => setEventForm({ ...eventForm, number_of_trees_Planted: e.target.value })}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {/* ── Save Energy Metrics ── */}
                    {eventForm.theme_name === "Save Energy" && (
                      <>
                        {eventForm.sub_theme === "Energy saving activities like switching off tube-lights, bulbs, electronic gadgets when not in use." ? (
                          <div className="brics-ref-field">
                            <label className="brics-ref-label">Electricity Consumption / Bill Reduction (%): <span className="req">*</span></label>
                            <input
                              type="number"
                              min="0"
                              max="100"
                              className="brics-ref-input"
                              placeholder="e.g. 15%"
                              value={eventForm.reductionPct}
                              onChange={(e) => setEventForm({ ...eventForm, reductionPct: e.target.value })}
                            />
                          </div>
                        ) : eventForm.sub_theme === "Knowledge building sessions on renewable sources of energy" ? (
                          <div className="brics-ref-input-grid">
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">Solar Panels Installed?</label>
                              <select
                                className="brics-ref-select"
                                value={eventForm.solarPanelInstalled}
                                onChange={(e) => setEventForm({ ...eventForm, solarPanelInstalled: e.target.value })}
                              >
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                              </select>
                            </div>
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">Solar Power Generated (kWh):</label>
                              <input
                                type="number"
                                min="0"
                                className="brics-ref-input"
                                placeholder="e.g. 450 units"
                                value={eventForm.solarUnitsGenerated}
                                onChange={(e) => setEventForm({ ...eventForm, solarUnitsGenerated: e.target.value })}
                              />
                            </div>
                          </div>
                        ) : (
                          /* By Default or "Competitions" or "Others" */
                          <>
                            <div className="brics-ref-field">
                              <label className="brics-ref-label">Electricity Consumption / Bill Reduction (%):</label>
                              <input
                                type="number"
                                min="0"
                                max="100"
                                className="brics-ref-input"
                                placeholder="e.g. 15%"
                                value={eventForm.reductionPct}
                                onChange={(e) => setEventForm({ ...eventForm, reductionPct: e.target.value })}
                              />
                            </div>
                            <div className="brics-ref-input-grid" style={{ marginTop: "8px" }}>
                              <div className="brics-ref-field">
                                <label className="brics-ref-label">Solar Panels Installed?</label>
                                <select
                                  className="brics-ref-select"
                                  value={eventForm.solarPanelInstalled}
                                  onChange={(e) => setEventForm({ ...eventForm, solarPanelInstalled: e.target.value })}
                                >
                                  <option value="yes">Yes</option>
                                  <option value="no">No</option>
                                </select>
                              </div>
                              <div className="brics-ref-field">
                                <label className="brics-ref-label">Solar Power Generated (kWh):</label>
                                <input
                                  type="number"
                                  min="0"
                                  className="brics-ref-input"
                                  placeholder="e.g. 450 units"
                                  value={eventForm.solarUnitsGenerated}
                                  onChange={(e) => setEventForm({ ...eventForm, solarUnitsGenerated: e.target.value })}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>

                {/* ── Right Column: Participation & Proof ── */}
                <div className="brics-form-column">
                  {/* Card 3: Age-wise Students Participated */}
                  <div className="brics-ref-section-card">
                    <div className="brics-ref-metric-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span>
                        <FaUsers style={{ color: "#16a34a" }} /> Age-wise Participation
                      </span>
                      <span className="brics-ref-tag-pill brics-ref-tag-pill--energy">
                        Total: {eventParticipantsTotal}
                      </span>
                    </div>
                    <div className="brics-ref-age-grid">
                      <div className="brics-ref-age-card">
                        <span className="brics-ref-age-card__label">Age 3–8</span>
                        <input
                          type="number"
                          min="0"
                          className="brics-ref-age-card__input"
                          placeholder="0"
                          value={eventForm.number_participant_age3to8}
                          onChange={(e) => setEventForm({ ...eventForm, number_participant_age3to8: e.target.value })}
                        />
                      </div>
                      <div className="brics-ref-age-card">
                        <span className="brics-ref-age-card__label">Age 8–11</span>
                        <input
                          type="number"
                          min="0"
                          className="brics-ref-age-card__input"
                          placeholder="0"
                          value={eventForm.number_participant_age8to11}
                          onChange={(e) => setEventForm({ ...eventForm, number_participant_age8to11: e.target.value })}
                        />
                      </div>
                      <div className="brics-ref-age-card">
                        <span className="brics-ref-age-card__label">Age 11–14</span>
                        <input
                          type="number"
                          min="0"
                          className="brics-ref-age-card__input"
                          placeholder="0"
                          value={eventForm.number_participant_age11to14}
                          onChange={(e) => setEventForm({ ...eventForm, number_participant_age11to14: e.target.value })}
                        />
                      </div>
                      <div className="brics-ref-age-card">
                        <span className="brics-ref-age-card__label">Age 14–18</span>
                        <input
                          type="number"
                          min="0"
                          className="brics-ref-age-card__input"
                          placeholder="0"
                          value={eventForm.number_participant_age14to18}
                          onChange={(e) => setEventForm({ ...eventForm, number_participant_age14to18: e.target.value })}
                        />
                      </div>
                      <div className="brics-ref-age-card">
                        <span className="brics-ref-age-card__label">Teachers / 18+</span>
                        <input
                          type="number"
                          min="0"
                          className="brics-ref-age-card__input"
                          placeholder="0"
                          value={eventForm.number_participant_age18plus}
                          onChange={(e) => setEventForm({ ...eventForm, number_participant_age18plus: e.target.value })}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Card 4: Geotagged Photos & Media Proof */}
                  <div className="brics-ref-section-card">
                    <div className="brics-ref-metric-title">
                      <FaCloudUploadAlt style={{ color: "#16a34a" }} /> Photographs & Proof (Max 5 Images)
                    </div>

                    <div className="brics-ref-field">
                      <label className="brics-ref-upload-zone">
                        <FaCloudUploadAlt className="brics-ref-upload-icon" />
                        <div className="brics-ref-upload-text">Upload Geotagged Photos of Event / Impact</div>
                        <div className="brics-ref-upload-subtext">JPEG, PNG up to 10MB each (Max 5 photos)</div>
                        <div className="brics-ref-upload-geotag-note">
                          <FaMapMarkerAlt style={{ color: "#e11d48", flexShrink: 0 }} />
                          <span>Photos must be geotagged. If a photo has no location, this device’s location is added — please allow location access when asked.</span>
                        </div>
                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          style={{ display: "none" }}
                          onChange={handleEventPhotoUpload}
                        />
                      </label>

                      {eventForm.photos && eventForm.photos.length > 0 && (
                        <div className="brics-ref-photo-grid">
                          {eventForm.photos.map((ph, idx) => (
                            <div key={idx} className="brics-ref-photo-thumb">
                              <img
                                src={typeof ph === "string" ? ph : (ph.photo_url || ph.url)}
                                alt={`Photo ${idx + 1}`}
                              />
                              <button
                                type="button"
                                className="brics-ref-photo-remove"
                                onClick={() => removeEventPhoto(idx)}
                                title="Remove photo"
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit CTA Row */}
              <div className="brics-form-submit-row">
                <button
                  type="submit"
                  className="brics-ref-submit-cta brics-ref-submit-cta--event"
                  disabled={isSubmittingEvent}
                >
                  {isSubmittingEvent
                    ? "Saving Report..."
                    : eventForm._id
                    ? "Update Details"
                    : "Submit Event Management Report"}{" "}
                  <FaArrowRight />
                </button>
              </div>
            </form>
          </>
        )}

        {/* ══════════════════════════════════════════════════════════════════════
            VIEW 2: FORM FOR "SAVE ENERGY" (Matching 1st Pop-up Theme)
            ══════════════════════════════════════════════════════════════════════ */}
        {activeView === "save_energy" && (
          <>
            {/* Top Sub-Nav with Back */}
            <div className="brics-ref-form-nav">
              <button
                type="button"
                className="brics-ref-back-btn"
                onClick={() => setActiveView("announcement")}
              >
                <FaArrowLeft /> Back to Overview
              </button>
              <div className="brics-ref-form-nav-theme-badge">
                <span>Theme:</span> <strong>Save Energy</strong>
              </div>
            </div>

            {/* Scrollable Form Body */}
            <form className="brics-ref-form-body" onSubmit={handleSubmitEnergy}>
              {energyLocked && (
                <div className="brics-locked-note">
                  <strong>This school has already reported.</strong> To change these details, please login to the school dashboard.
                  <button type="button" className="brics-locked-login" onClick={() => setShowLoginPrompt(true)}>Login to update</button>
                </div>
              )}
              <fieldset disabled={energyLocked} className="brics-lockable">
              <div className="brics-form-two-column-grid">
                {/* ── Left Column: Metrics & Initiatives ── */}
                <div className="brics-form-column">
                  {/* Card 1: Reduction in Electricity Bills (Original Metric) */}
                  <div className="brics-ref-section-card brics-ref-section-card--highlight-energy">
                    <div className="brics-ref-metric-title">
                      <FaBolt style={{ color: "#16a34a" }} /> Reduction in Electricity Bills
                    </div>

                    <div className="brics-ref-input-grid">
                      <div className="brics-ref-field">
                        <label className="brics-ref-label">
                          Bill Reduction (%):
                        </label>
                        <input
                          type="number"
                          className="brics-ref-input"
                          placeholder="e.g. 15"
                          min="0"
                          max="100"
                          value={energyForm.reductionPct}
                          onChange={(e) => setEnergyForm({ ...energyForm, reductionPct: e.target.value })}
                        />
                      </div>

                      <div className="brics-ref-field">
                        <label className="brics-ref-label">
                          Savings (₹ or kWh):
                        </label>
                        <div style={{ display: "flex", gap: "6px" }}>
                          <input
                            type="number"
                            className="brics-ref-input"
                            placeholder="e.g. 3500"
                            min="0"
                            value={energyForm.reductionAmount}
                            onChange={(e) => setEnergyForm({ ...energyForm, reductionAmount: e.target.value })}
                          />
                          <select
                            className="brics-ref-select"
                            style={{ width: "80px" }}
                            value={energyForm.reductionUnit}
                            onChange={(e) => setEnergyForm({ ...energyForm, reductionUnit: e.target.value })}
                          >
                            <option value="%">%</option>
                            <option value="₹">₹</option>
                            <option value="kWh">kWh</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="brics-ref-field" style={{ marginTop: "6px" }}>
                      <label className="brics-ref-label">Summary / Details:</label>
                      <input
                        type="text"
                        className="brics-ref-input"
                        placeholder="e.g. Achieved 250 kWh monthly power savings via 1-hr daily switch-off"
                        value={energyForm.electricityBillReduction}
                        onChange={(e) => setEnergyForm({ ...energyForm, electricityBillReduction: e.target.value })}
                      />
                    </div>
                  </div>

                  {/* Card 2: Solar Power Generation (Original Metric) */}
                  <div className="brics-ref-section-card brics-ref-section-card--highlight-energy">
                    <div className="brics-ref-metric-title">
                      <FaSolarPanel style={{ color: "#16a34a" }} /> Solar Power Generation
                    </div>

                    <div className="brics-ref-field">
                      <label className="brics-ref-label">
                        Is a solar panel installed in the school? <span className="req">*</span>
                      </label>
                      <div className="brics-ref-pill-toggle">
                        <div className="brics-ref-toggle-opt">
                          <input
                            type="radio"
                            id="solar-opt-yes"
                            name="solarInstalled"
                            value="yes"
                            checked={energyForm.solarPanelInstalled === "yes"}
                            onChange={() => setEnergyForm({ ...energyForm, solarPanelInstalled: "yes" })}
                          />
                          <label htmlFor="solar-opt-yes">
                            <FaCheckCircle /> Yes, Installed
                          </label>
                        </div>

                        <div className="brics-ref-toggle-opt is-no">
                          <input
                            type="radio"
                            id="solar-opt-no"
                            name="solarInstalled"
                            value="no"
                            checked={energyForm.solarPanelInstalled === "no"}
                            onChange={() => setEnergyForm({ ...energyForm, solarPanelInstalled: "no", solarUnitsGenerated: "" })}
                          />
                          <label htmlFor="solar-opt-no">
                            No Solar Panels
                          </label>
                        </div>
                      </div>
                    </div>

                    {energyForm.solarPanelInstalled === "yes" && (
                      <div className="brics-ref-field" style={{ marginTop: "10px" }}>
                        <label className="brics-ref-label">
                          Units Generated (kWh / Units): <span className="req">*</span>
                        </label>
                        <input
                          type="number"
                          className="brics-ref-input"
                          placeholder="e.g. 450 units generated"
                          min="0"
                          value={energyForm.solarUnitsGenerated}
                          onChange={(e) => setEnergyForm({ ...energyForm, solarUnitsGenerated: e.target.value })}
                          required={energyForm.solarPanelInstalled === "yes"}
                        />
                      </div>
                    )}
                  </div>

                  {/* Card 3: Energy Conservation Practices & Activity Date (Balanced on Left Column) */}
                  <div className="brics-ref-section-card">
                    <div className="brics-ref-metric-title">
                      <FaCalendarAlt style={{ color: "#16a34a" }} /> Energy Conservation Practices
                    </div>

                    <div className="brics-ref-input-grid">
                      <div className="brics-ref-field">
                        <label className="brics-ref-label">1-Hour Switch-Off Observed?</label>
                        <select
                          className="brics-ref-select"
                          value={energyForm.oneHourSwitchOffObserved}
                          onChange={(e) => setEnergyForm({ ...energyForm, oneHourSwitchOffObserved: e.target.value })}
                        >
                          <option value="yes">Yes, Observed</option>
                          <option value="no">Not Observed</option>
                        </select>
                      </div>

                      <div className="brics-ref-field">
                        <label className="brics-ref-label">Energy Audit Conducted?</label>
                        <select
                          className="brics-ref-select"
                          value={energyForm.energyAuditDone}
                          onChange={(e) => setEnergyForm({ ...energyForm, energyAuditDone: e.target.value })}
                        >
                          <option value="yes">Yes, Conducted</option>
                          <option value="no">Planned / In Progress</option>
                        </select>
                      </div>
                    </div>

                    <div className="brics-ref-field" style={{ marginTop: "8px" }}>
                      <label className="brics-ref-label">Activity Date:</label>
                      <input
                        type="date"
                        className="brics-ref-input"
                        max={todayIST()}
                        value={energyForm.activityDate}
                        onChange={(e) => setEnergyForm({ ...energyForm, activityDate: e.target.value })}
                      />
                    </div>
                  </div>
                </div>

                {/* ── Right Column: Participation & Proof ── */}
                <div className="brics-form-column">
                  {/* Card 4: Age-wise Students Participated */}
                  <div className="brics-ref-section-card brics-ref-section-card--highlight-energy">
                    <div className="brics-ref-metric-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span>
                        <FaUsers style={{ color: "#16a34a" }} /> Age-wise Participation
                      </span>
                      <span className="brics-ref-tag-pill brics-ref-tag-pill--energy">
                        Total: {energyAgeTotal > 0 ? energyAgeTotal : (Number(energyForm.studentsInvolved) || 0)}
                      </span>
                    </div>
                    <div className="brics-ref-age-grid">
                      {AGE_PARTICIPATION_BRACKETS.map((b) => (
                        <div key={b.key} className="brics-ref-age-card">
                          <span className="brics-ref-age-card__label">{b.label}</span>
                          <input
                            type="number"
                            min="0"
                            className="brics-ref-age-card__input"
                            placeholder="0"
                            value={energyForm[b.key]}
                            onChange={(e) => {
                              const val = e.target.value;
                              const updated = { ...energyForm, [b.key]: val };
                              const sum = AGE_PARTICIPATION_BRACKETS.reduce((acc, item) => {
                                const v = item.key === b.key ? val : energyForm[item.key];
                                return acc + (Number(v) || 0);
                              }, 0);
                              updated.studentsInvolved = sum > 0 ? String(sum) : (val ? val : updated.studentsInvolved);
                              setEnergyForm(updated);
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Card 5: Photographs & Proof */}
                  <div className="brics-ref-section-card">
                    <div className="brics-ref-metric-title">
                      <FaCloudUploadAlt style={{ color: "#16a34a" }} /> Photographs & Proof (Optional)
                    </div>

                    <div className="brics-ref-field">
                      <label className="brics-ref-upload-zone">
                        <FaCloudUploadAlt className="brics-ref-upload-icon" />
                        <div className="brics-ref-upload-text">Upload switch-off, audit, or solar photos</div>
                        <div className="brics-ref-upload-subtext">JPEG, PNG up to 5MB</div>
                        <div className="brics-ref-upload-geotag-note">
                          <FaMapMarkerAlt style={{ color: "#e11d48", flexShrink: 0 }} />
                          <span>Photos must be geotagged. If a photo has no location, this device’s location is added — please allow location access when asked.</span>
                        </div>
                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          style={{ display: "none" }}
                          onChange={(e) => handlePhotoUpload(e, "energy")}
                        />
                      </label>

                      {energyForm.photos.length > 0 && (
                        <div className="brics-ref-photo-grid">
                          {energyForm.photos.map((p, idx) => (
                            <div key={idx} className="brics-ref-photo-thumb">
                              <img src={p.url} alt={`energy-${idx}`} />
                              <button
                                type="button"
                                className="brics-ref-photo-remove"
                                onClick={() => removePhoto(idx, "energy")}
                              >
                                ✕
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit CTA Row */}
              <div className="brics-form-submit-row">
                <button
                  type="submit"
                  className="brics-ref-submit-cta brics-ref-submit-cta--energy"
                  disabled={isSubmittingEnergy || energyLocked}
                >
                  {isSubmittingEnergy ? "Submitting..." : energyLocked ? "Login to update" : isEnergyDone ? "Update Details" : "Submit Save Energy Report"}{" "}
                  <FaArrowRight />
                </button>
              </div>
              </fieldset>
            </form>
          </>
        )}

        {/* ══════════════════════════════════════════════════════════════════════
            VIEW 3: FORM FOR "ADOPT HEALTHY LIFESTYLES" (Matching 1st Pop-up Theme)
            ══════════════════════════════════════════════════════════════════════ */}
        {activeView === "adopt_lifestyle" && (
          <>
            {/* Top Sub-Nav with Back */}
            <div className="brics-ref-form-nav">
              <button
                type="button"
                className="brics-ref-back-btn"
                onClick={() => setActiveView("announcement")}
              >
                <FaArrowLeft /> Back to Overview
              </button>
              <div className="brics-ref-form-nav-theme-badge">
                <span>Theme:</span> <strong>Adopt Healthy Lifestyles</strong>
              </div>
            </div>

            {/* Scrollable Form Body */}
            <form className="brics-ref-form-body" onSubmit={handleSubmitLifestyle}>
              {lifestyleLocked && (
                <div className="brics-locked-note">
                  <strong>This school has already reported.</strong> To change these details, please login to the school dashboard.
                  <button type="button" className="brics-locked-login" onClick={() => setShowLoginPrompt(true)}>Login to update</button>
                </div>
              )}
              <fieldset disabled={lifestyleLocked} className="brics-lockable">
              <div className="brics-form-two-column-grid">
                {/* ── Left Column: Sub-Theme, Metrics & Date ── */}
                <div className="brics-form-column">
                  {/* Card 1: Four-Bin System for Waste Segregation (Original Metric) */}
                  <div className="brics-ref-section-card brics-ref-section-card--highlight-lifestyle">
                    <div className="brics-ref-metric-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
                      <span>
                        <FaTrashAlt style={{ color: "#0284c7" }} /> Four-Bin System for Waste Segregation
                      </span>
                    </div>

                    <div className="brics-ref-field">
                      <label className="brics-ref-label">Four-Bin System Installed in School? <span className="req">*</span></label>
                      <div className="brics-ref-pill-toggle">
                        <div className="brics-ref-toggle-opt is-blue">
                          <input
                            type="radio"
                            id="four-bin-opt-yes"
                            name="fourBinsInstalled"
                            value="yes"
                            checked={lifestyleForm.fourBinSystemInstalled === "yes"}
                            onChange={() => setLifestyleForm({ ...lifestyleForm, fourBinSystemInstalled: "yes" })}
                          />
                          <label htmlFor="four-bin-opt-yes">
                            <FaCheckCircle /> Yes, Installed
                          </label>
                        </div>

                        <div className="brics-ref-toggle-opt is-no">
                          <input
                            type="radio"
                            id="four-bin-opt-no"
                            name="fourBinsInstalled"
                            value="no"
                            checked={lifestyleForm.fourBinSystemInstalled === "no"}
                            onChange={() => setLifestyleForm({ ...lifestyleForm, fourBinSystemInstalled: "no" })}
                          />
                          <label htmlFor="four-bin-opt-no">
                            No 4-Bin System
                          </label>
                        </div>
                      </div>
                    </div>

                    {lifestyleForm.fourBinSystemInstalled === "yes" && (
                      <>
                        <label className="brics-ref-label" style={{ marginTop: "12px" }}>
                          Four-Bin Segregation Setup:
                        </label>
                        <div className="brics-ref-bin-grid">
                          {FOUR_BINS_DEFAULTS.map((bin) => (
                            <div key={bin.key} className="brics-ref-bin-item">
                              <span className={`brics-ref-bin-badge brics-ref-bin-badge--${bin.color}`}>✓</span>
                              <h6>{bin.name} ({bin.label})</h6>
                            </div>
                          ))}
                        </div>

                        <div className="brics-ref-input-grid">
                          <div className="brics-ref-field">
                            <label className="brics-ref-label">
                              Number of 4-Bin Sets: <span className="req">*</span>
                            </label>
                            <input
                              type="number"
                              className="brics-ref-input"
                              min="1"
                              placeholder="e.g. 5 sets"
                              value={lifestyleForm.binsCount}
                              onChange={(e) => setLifestyleForm({ ...lifestyleForm, binsCount: e.target.value })}
                              required={lifestyleForm.fourBinSystemInstalled === "yes"}
                            />
                          </div>

                          <div className="brics-ref-field">
                            <label className="brics-ref-label">Segregation at Source?</label>
                            <select
                              className="brics-ref-select"
                              value={lifestyleForm.wasteSegregatedAtSource}
                              onChange={(e) => setLifestyleForm({ ...lifestyleForm, wasteSegregatedAtSource: e.target.value })}
                            >
                              <option value="yes">Yes, Practiced</option>
                              <option value="no">Needs Awareness</option>
                            </select>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="brics-ref-field" style={{ marginTop: "10px" }}>
                      <label className="brics-ref-label">Trees / Saplings Planted (Optional):</label>
                      <input
                        type="number"
                        className="brics-ref-input"
                        min="0"
                        placeholder="e.g. 20 saplings"
                        value={lifestyleForm.number_of_trees_Planted}
                        onChange={(e) => setLifestyleForm({ ...lifestyleForm, number_of_trees_Planted: e.target.value })}
                      />
                    </div>
                  </div>

                  {/* Card 2: Drive Date & Remarks */}
                  <div className="brics-ref-section-card">
                    <div className="brics-ref-metric-title">
                      <FaCalendarAlt style={{ color: "#0284c7" }} /> Drive Date & Remarks
                    </div>

                    <div className="brics-ref-field">
                      <label className="brics-ref-label">Activity Date:</label>
                      <input
                        type="date"
                        className="brics-ref-input"
                        max={todayIST()}
                        value={lifestyleForm.activityDate}
                        onChange={(e) => setLifestyleForm({ ...lifestyleForm, activityDate: e.target.value })}
                      />
                    </div>

                    <div className="brics-ref-field" style={{ marginTop: "10px" }}>
                      <label className="brics-ref-label">Remarks / Measures Taken:</label>
                      <textarea
                        rows={2}
                        className="brics-ref-textarea"
                        placeholder="e.g. Four-bin sets placed at cafeteria, entrance, and classroom wings; students instructed on source segregation daily."
                        value={lifestyleForm.remarks}
                        onChange={(e) => setLifestyleForm({ ...lifestyleForm, remarks: e.target.value })}
                      />
                    </div>
                  </div>
                </div>

                {/* ── Right Column: Participation & Proof ── */}
                <div className="brics-form-column">
                  {/* Card 4: Age-wise Students Participated */}
                  <div className="brics-ref-section-card brics-ref-section-card--highlight-lifestyle">
                    <div className="brics-ref-metric-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span>
                        <FaUsers style={{ color: "#0284c7" }} /> Age-wise Participation
                      </span>
                      <span className="brics-ref-tag-pill brics-ref-tag-pill--lifestyle">
                        Total: {lifestyleAgeTotal > 0 ? lifestyleAgeTotal : (Number(lifestyleForm.studentsSensitised) || 0)}
                      </span>
                    </div>
                    <div className="brics-ref-age-grid">
                      {AGE_PARTICIPATION_BRACKETS.map((b) => (
                        <div key={b.key} className="brics-ref-age-card brics-ref-age-card--lifestyle">
                          <span className="brics-ref-age-card__label brics-ref-age-card__label--lifestyle">{b.label}</span>
                          <input
                            type="number"
                            min="0"
                            className="brics-ref-age-card__input"
                            placeholder="0"
                            value={lifestyleForm[b.key]}
                            onChange={(e) => {
                              const val = e.target.value;
                              const updated = { ...lifestyleForm, [b.key]: val };
                              const sum = AGE_PARTICIPATION_BRACKETS.reduce((acc, item) => {
                                const v = item.key === b.key ? val : lifestyleForm[item.key];
                                return acc + (Number(v) || 0);
                              }, 0);
                              updated.studentsSensitised = sum > 0 ? String(sum) : (val ? val : updated.studentsSensitised);
                              setLifestyleForm(updated);
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Card 5: Photo Upload Zone */}
                  <div className="brics-ref-section-card">
                    <div className="brics-ref-metric-title">
                      <FaCloudUploadAlt style={{ color: "#0284c7" }} /> Photographs & Proof (Optional)
                    </div>

                    <div className="brics-ref-field">
                      <label className="brics-ref-upload-zone">
                        <FaCloudUploadAlt className="brics-ref-upload-icon" style={{ color: "#0284c7" }} />
                        <div className="brics-ref-upload-text">Upload photos of bins or student awareness sessions</div>
                        <div className="brics-ref-upload-subtext">JPEG, PNG up to 5MB</div>
                        <div className="brics-ref-upload-geotag-note">
                          <FaMapMarkerAlt style={{ color: "#e11d48", flexShrink: 0 }} />
                          <span>Photos must be geotagged. If a photo has no location, this device’s location is added — please allow location access when asked.</span>
                        </div>
                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          style={{ display: "none" }}
                          onChange={(e) => handlePhotoUpload(e, "lifestyle")}
                        />
                      </label>

                      {lifestyleForm.photos.length > 0 && (
                        <div className="brics-ref-photo-grid">
                          {lifestyleForm.photos.map((p, idx) => (
                            <div key={idx} className="brics-ref-photo-thumb">
                              <img src={p.url} alt={`lifestyle-${idx}`} />
                              <button
                                type="button"
                                className="brics-ref-photo-remove"
                                onClick={() => removePhoto(idx, "lifestyle")}
                              >
                                ✕
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit CTA Row */}
              <div className="brics-form-submit-row">
                <button
                  type="submit"
                  className="brics-ref-submit-cta brics-ref-submit-cta--lifestyle"
                  disabled={isSubmittingLifestyle || lifestyleLocked}
                >
                  {isSubmittingLifestyle ? "Submitting..." : lifestyleLocked ? "Login to update" : isLifestyleDone ? "Update Details" : "Submit Healthy Lifestyle Report"}{" "}
                  <FaArrowRight />
                </button>
              </div>
              </fieldset>
            </form>
          </>
        )}

        {/* ══════════════════════════════════════════════════════════════════════
            VIEW 4: SUCCESS CONFIRMATION VIEW (Matching 1st Pop-up Theme)
            ══════════════════════════════════════════════════════════════════════ */}
        {activeView === "success" && (
          <>
            <div className="brics-ref-success-card">
              <div className="brics-ref-success-icon">
                <FaCheckCircle />
              </div>

              <h3 className="brics-ref-success-title">
                {successType === "energy"
                  ? (isEnergyDone ? "Save Energy Details Updated!" : "Save Energy Report Submitted!")
                  : (isLifestyleDone ? "Adopt Healthy Lifestyle Details Updated!" : "Adopt Healthy Lifestyle Report Submitted!")}
              </h3>

              <p className="brics-ref-success-desc">
                Thank you for contributing to the{" "}
                <strong>BRICS Sustainable Lifestyle Week 2026</strong> under India’s BRICS Chairship.
                Your school’s metrics have been recorded.
              </p>

              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {successType === "energy" && !isLifestyleDone && (
                  <button
                    type="button"
                    className="brics-ref-submit-cta brics-ref-submit-cta--lifestyle"
                    onClick={() => setActiveView("adopt_lifestyle")}
                  >
                    <FaHeartbeat /> Now Report "Adopt Healthy Lifestyle" <FaArrowRight />
                  </button>
                )}

                {successType === "lifestyle" && !isEnergyDone && (
                  <button
                    type="button"
                    className="brics-ref-submit-cta brics-ref-submit-cta--energy"
                    onClick={() => setActiveView("save_energy")}
                  >
                    <FaBolt /> Now Report "Save Energy" <FaArrowRight />
                  </button>
                )}

                <button
                  type="button"
                  className="brics-ref-back-btn"
                  style={{ justifyContent: "center", padding: "10px 18px", marginTop: "4px" }}
                  onClick={onClose}
                >
                  Return to School Dashboard
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Editing an already-submitted report needs the school login. */}
      {showLoginPrompt && (
        <div className="brics-login-overlay" onClick={() => setShowLoginPrompt(false)}>
          <div className="brics-login-shell" onClick={(ev) => ev.stopPropagation()}>
            <SchoolLoginModel handleViewexit={() => setShowLoginPrompt(false)} />
          </div>
        </div>
      )}
    </div>
  );
}
